import BaseApi from './baseApi';
import IStock from '../models/IStock';
import IOutboundDetail from '../models/IOutboundDetail';
import { SELL_STATUS_EXCLUDED_SQL_FILTER } from '../../config/constants';
export default class StockApi extends BaseApi {
    constructor() {
        super("dataaccess", "Stock");
    }

    async GetStockByPalletIds(idSell: string, idCustomer: string) {
        let json : string = this.getJsonReadByPalletIds(idSell, idCustomer);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var stock: IStock[] = [];
            stock = response.data as IStock[];
            return stock;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }
    
    async GetStockGroupByWarehousesId(
        idWarehouses: string[],
        idCompany: string,
        hasScanner: boolean
    ): Promise<IStock[]> {
        // 📌 Selección dinámica del JSON según hasScanner
        let json: string;
        if (hasScanner) {
            json = this.getJsonReadGroupByWarehousesIdsWithScanner(idWarehouses, idCompany);
        } else {
            json = this.getJsonReadGroupByWarehousesIds(idWarehouses, idCompany);
        }

        // 📌 Llamada a la API
        const response = await this.api.post('read', json);

        if (!response) return [];

        if (response.isSuccess) {
            return response.data as IStock[];
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async GetStockByInboundIdAndWarehouse(inboundCode: string, warehouseId: string) : Promise<IStock[]> {
        let json : string = this.getJsonReadByInboundIdAndWarehouseId(inboundCode, warehouseId);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var stock: IStock[] = [];
            stock = response.data as IStock[];
            return stock;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async GetStockByInboundCodeAndWarehouse(inboundCode: string, warehouseId: string) : Promise<IStock[]> {
        const json = this.getJsonReadStockByInboundCodeAndWarehouse(inboundCode, warehouseId);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var stock: IStock[] = [];
            stock = response.data as IStock[];
            return stock;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async GetStockByInboundIdAndWarehouseForLabels(inboundCode: string, warehouseId: string) : Promise<IStock[]> {
        let json : string = this.getJsonReadByInboundIdAndWarehouseIdForLabels(inboundCode);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var stock: IStock[] = [];
            stock = response.data as IStock[];
            return stock;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async GetStockByInboundId(inboundId: string) : Promise<IStock[]> {
        let json : string = this.getJsonReadByInboundId(inboundId);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var stock: IStock[] = [];
            stock = response.data as IStock[];
            return stock;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async GetStockGroupByPallets(idWarehouses: string[]) : Promise<IStock[]> {
        let json : string = this.getJsonReadGroupByPallets(idWarehouses);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var stock: IStock[] = [];
            stock = response.data as IStock[];
            return stock;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async GetStockGroupByPalletsAndCustomer(idCustomer: string) : Promise<IStock[]> {
        let json : string = this.getJsonReadGroupByPalletsAndCustomer(idCustomer);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var stock: IStock[] = [];
            stock = response.data as IStock[];
            return stock;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async GetStockGroupByPalletsAndCustomerAndInboundCode(idCustomer: string, inboundCode: string): Promise<IStock[]> {
        const json: string = this.getJsonReadGroupByPalletsAndCustomerAndInboundCode(idCustomer, inboundCode);
        const response = await this.api.post('read', json);
        if (!response) return [];

        if (response.isSuccess) {
            let stock: IStock[] = response.data as IStock[];
            return stock;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async GetStockGroupByCustomer(idCustomer: string) : Promise<IStock[]> {
        let json : string = this.getJsonReadGroupByCustomer(idCustomer);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var stock: IStock[] = [];
            stock = response.data as IStock[];
            return stock;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async GetStockGroupByCustomerOutbound(idCustomer: string) : Promise<IStock[]> {
        let json : string = this.getJsonReadGroupByCustomerOutbound(idCustomer);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var stock: IStock[] = [];
            stock = response.data as IStock[];
            return stock;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async GetStockGroupByGoods(idGoods: string[], idInboundsDeliveryNoteDetails: string[]) {
        let json : string = this.getJsonReadGroupByGoods(idGoods, idInboundsDeliveryNoteDetails);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var stock: IStock[] = [];
            stock = response.data as IStock[];
            return stock;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async GetInboundsCodeInStockByCustomerId(idCustomer: string) {
        let json : string = this.getJsonReadInboundsCodeByCustomerId(idCustomer);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var stock: IStock[] = [];
            stock = response.data as IStock[];
            return stock;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async GetInboundsCodeInStock(idCompany: string) {
        let json : string = this.getJsonReadInboundsCodeInStock(idCompany);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var stock: IStock[] = [];
            stock = response.data as IStock[];
            return stock;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async GetStockPalletsAmount(item: any) {
        let json : string = this.getJsonReadStockPalletsAmount(item);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var stock: IStock[] = [];
            stock = response.data as IStock[];
            return stock;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async CanDeleteProduct(goodId: string) : Promise<boolean> {
        let json: string = this.getJsonReadCanDeleteProduct(goodId);
        const response = await this.api.post('read', json);
        if (!response) return false;
        if (response.isSuccess) {
            var stock: IStock[] = [];
            stock = response.data as IStock[];
            return stock.length === 0;
        } else {
            this.modelState = response.errorState;
            return false;
        }
    }

    async UpdateStockLocation(stock: IStock) : Promise<boolean> {
        const json = this.getJsonUpdateLocation(stock);
        const response = await this.api.post('SaveWithParameters', json);
        return this.isSuccess(response);
    }

    async UpdateStockPalletType(stock: IStock) : Promise<boolean> {
        const json = this.getJsonUpdatePalletType(stock);
        const response = await this.api.post('SaveWithParameters', json);
        return this.isSuccess(response);
    }

    async GetProductsInUse(goodId: string): Promise<boolean> {
        const json: string = this.getJsonReadStockGoodsInUse(goodId);
        const response = await this.api.post('read', json);

        if (!response) return false;

        if (response.isSuccess) {
            const stock = response.data as IStock[];

            // Si hay al menos un registro → está en uso
            return stock.length > 0;
        } else {
            this.modelState = response.errorState;

            // ❗ Puedes elegir si en error se considera en uso o no
            return false;
        }
    }

    private getJsonReadStockGoodsInUse(goodId: string): any {
        // fecha de hoy en formato YYYY-MM-DD
        const today = new Date().toISOString().substring(0, 10);

        const json = {
            "fields": [
                {
                    "Item1": "StockDetail",
                    "Item2": "idGood"
                }
            ],
            "tables": [
                {
                    "Item1": "StockDetail"
                }
            ],
            "conditions": [
                {
                    "Item1": "StockDetail",
                    "Item2": "IdOutboundDeliveryNoteDetail",
                    "Item3": "IS",
                    "Item4": "null",
                    "Item5": "AND"
                },
                {
                    "Item1": "StockDetail",
                    "Item2": "IdOutboundDetail",
                    "Item3": "IS",
                    "Item4": "null",
                    "Item5": "AND"
                },

                // (DateOut is null OR DateOut >= today)
                {
                    "Item1": "(",
                    "Item2": "StockDetail.DateOut IS NULL",
                    "Item3": "OR",
                    "Item4": "",
                    "Item5": ""
                },
                {
                    "Item1": "FORMAT(StockDetail.DateOut,'yyyy-MM-dd')",
                    "Item2": ">=",
                    "Item3": today,
                    "Item4": "",
                    "Item5": ") AND"
                },

                {
                    "Item1": "StockDetail",
                    "Item2": "IdGood",
                    "Item3": "=",
                    "Item4": goodId
                }
            ]
        };

        return json;
    }
   
    private getJsonReadCanDeleteProduct(goodId: string): any {
        const json = {
            "fields": [{
                "Item1": "StockDetail",
                "Item2": "id"
            }],
            "tables": [{
                "Item1": "StockDetail"
            }],
            "conditions": [{
                "Item1": "StockDetail",
                "Item2": "IdOutboundDeliveryNoteDetail",
                "Item3": "IS",
                "Item4": "null",
                "Item5": "AND"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdOutboundDetail",
                "Item3": "IS",
                "Item4": "null",
                "Item5": "AND"
            }, {
                "Item1": "StockDetail",
                "Item2": "DateOut",
                "Item3": "IS",
                "Item4": "null",
                "Item5": "AND"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdGood",
                "Item3": "=",
                "Item4": goodId
            }]
        };
        return json;
    }

    private getJsonUpdateLocation(stock: IStock) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "location",
                "Item2": stock.location
            }],
            "table": "StockDetail",
            "conditions": [{
                "Item1": "StockDetail",
                "Item2": "idPallet",
                "Item3": "=",
                "Item4": stock.idPallet
            }]
        };
        return json;
    }

    private getJsonUpdatePalletType(stock: IStock) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "idListPallet",
                "Item2": stock.idListPallet
            }],
            "table": "StockDetail",
            "conditions": [{
                "Item1": "StockDetail",
                "Item2": "idPallet",
                "Item3": "=",
                "Item4": stock.idPallet
            }]
        };
        return json;
    }

    private getJsonReadByInboundIdAndWarehouseId(inboundId: string, warehouseId: string) : any {
        const json = {
            "fields": [{
                "Item1": "Warehouses",
                "Item2": "name as warehouseName"
            }, {
                "Item1": "StockDetail",
                "Item2": "idCustomer"
            }, {
                "Item1": "Customers",
                "Item2": "name as customerName"
            }, {
                "Item1": "ISNULL(Inbounds",
                "Item2": "code, (SELECT Code FROM Inbounds WHERE Id IN (SELECT IdInbound FROM Transformations WHERE Id IN (SELECT IdTransformation FROM TransformationsPalletsDestination WHERE Id = StockDetail.IdTransformationPalletDestination)))) as codeInbounds"
            }, {
                "Item1": "Inbounds",
                "Item2": "codeDestination"
            }, {
                "Item1": "Inbounds",
                "Item2": "referenceInboundCode as referenceInboundCode"
            }, {
                "Item1": "ListPalletTypes",
                "Item2": "name as listPalletName"
            }, {
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "Id as IdInboundDeliveryNoteDetail"
            }, {
                "Item1": "Goods",
                "Item2": "name as goodName"
            }, {
                "Item1": "COUNT(DISTINCT(StockDetail",
                "Item2": "IdPallet)) as palletsAmount"
            }, {
                "Item1": "SUM(StockDetail",
                "Item2": "totalCases) as totalCases"
            }, {
                "Item1": "StockDetail",
                "Item2": "goodsPerCase"
            }, {
                "Item1": "SUM(StockDetail",
                "Item2": "totalGoods) as totalGoods"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "bestBeforeDate"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "language"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "documentation"
            }, {
                "Item1": "StockDetail",
                "Item2": "idPallet"
            }, {
                "Item1": "StockDetail",
                "Item2": "location"
            }, {
                "Item1": "StockDetail",
                "Item2": "idGood"
            }, {
                "Item1": "IIF(StockDetail",
                "Item2": "IdTransformationPalletDestination IS NULL, 'No', 'Yes') AS isTransformed"
            }],
            "tables": [{
                "Item1": "StockDetail"
            }, {
                "Item1": "Warehouses"
            }, {
                "Item1": "Customers"
            }, {
                "Item1": "Goods"
            }, {
                "Item1": "ListPalletTypes"
            }, {
                "Item1": "InboundsDeliveryNotesDetail"
            }, {
                "Item1": "InboundsDetail"
            }, {
                "Item1": "Inbounds"
            }, {
                "Item1": "TransformationsPalletsDestination"
            }, {
                "Item1": "Transformations"
            }],
            "conditions": [{
                "Item1": "Inbounds",
                "Item2": "id",
                "Item3": "=",
                "Item4": inboundId,
                "Item5": "AND"
            }, {
                "Item1": "Inbounds",
                "Item2": "deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdOutboundDeliveryNoteDetail",
                "Item3": "IS",
                "Item4": "null",
                "Item5": "AND"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdOutboundDetail",
                "Item3": "IS",
                "Item4": "null",
                "Item5": "AND"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdNoticeOfLossDetail",
                "Item3": "IS",
                "Item4": "null",
                "Item5": "AND"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdWarehouse",
                "Item3": "=",
                "Item4": warehouseId
            }],
            "joins": [{
                "Item1": "StockDetail",
                "Item2": "IdWarehouse",
                "Item3": "Warehouses",
                "Item4": "Id"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdCustomer",
                "Item3": "Customers",
                "Item4": "Id"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdGood",
                "Item3": "Goods",
                "Item4": "Id"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdListPallet",
                "Item3": "ListPalletTypes",
                "Item4": "Id"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdInboundDeliveryNoteDetail",
                "Item3": "InboundsDeliveryNotesDetail",
                "Item4": "Id"
            }, {
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "IdInboundDetail",
                "Item3": "InboundsDetail",
                "Item4": "Id"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "IdInbound",
                "Item3": "Inbounds",
                "Item4": "Id"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdTransformationPalletDestination",
                "Item3": "TransformationsPalletsDestination",
                "Item4": "Id"
            }, {
                "Item1": "TransformationsPalletsDestination",
                "Item2": "IdTransformation",
                "Item3": "Transformations",
                "Item4": "Id"
            }],
            "groupBy": [{
                "Item1": "Warehouses.name"
            }, {
                "Item1": "Customers.name"
            }, {
                "Item1": "Goods.name"
            }, {
                "Item1": "Inbounds.code"
            }, {
                "Item1": "Inbounds.codeDestination"
            }, {
                "Item1": "Inbounds.referenceInboundCode"
            }, {
                "Item1": "ListPalletTypes.name"
            }, {
                "Item1": "StockDetail.idGood"
            }, {
                "Item1": "StockDetail.idCustomer"
            }, {
                "Item1": "StockDetail.idPallet"
            }, {
                "Item1": "StockDetail.location"
            }, {
                "Item1": "StockDetail.totalCases"
            }, {
                "Item1": "StockDetail.goodsPerCase"
            }, {
                "Item1": "StockDetail.totalGoods"
            }, {
                "Item1": "InboundsDetail.bestBeforeDate"
            }, {
                "Item1": "InboundsDeliveryNotesDetail.Id"
            }, {
                "Item1": "StockDetail.IdWarehouse"
            }, {
                "Item1": "InboundsDetail.language"
            }, {
                "Item1": "InboundsDetail.documentation"
            }, {
                "Item1": "StockDetail.IdTransformationPalletDestination"
            }]
        };
        return json;
    }

    private getJsonReadStockByInboundCodeAndWarehouse(inboundCode: string, warehouseId: string) : any {
        const json = {
            "fields": [{
                "Item1": "Warehouses",
                "Item2": "name as warehouseName"
            }, {
                "Item1": "StockDetail",
                "Item2": "idCustomer"
            }, {
                "Item1": "Customers",
                "Item2": "name as customerName"
            }, {
                "Item1": "ISNULL(Inbounds",
                "Item2": "code, (SELECT Code FROM Inbounds WHERE Id IN (SELECT IdInbound FROM Transformations WHERE Id IN (SELECT IdTransformation FROM TransformationsPalletsDestination WHERE Id = StockDetail.IdTransformationPalletDestination)))) as codeInbounds"
            }, {
                "Item1": "Inbounds",
                "Item2": "codeDestination"
            }, {
                "Item1": "Inbounds",
                "Item2": "referenceInboundCode as referenceInboundCode"
            }, {
                "Item1": "ListPalletTypes",
                "Item2": "name as listPalletName"
            }, {
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "Id as IdInboundDeliveryNoteDetail"
            }, {
                "Item1": "Goods",
                "Item2": "name as goodName"
            }, {
                "Item1": "COUNT(DISTINCT(StockDetail",
                "Item2": "IdPallet)) as palletsAmount"
            }, {
                "Item1": "SUM(StockDetail",
                "Item2": "totalCases) as totalCases"
            }, {
                "Item1": "StockDetail",
                "Item2": "goodsPerCase"
            }, {
                "Item1": "SUM(StockDetail",
                "Item2": "totalGoods) as totalGoods"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "bestBeforeDate"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "language"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "documentation"
            }, {
                "Item1": "StockDetail",
                "Item2": "idPallet"
            }, {
                "Item1": "StockDetail",
                "Item2": "location"
            }, {
                "Item1": "StockDetail",
                "Item2": "idGood"
            }, {
                "Item1": "IIF(StockDetail",
                "Item2": "IdTransformationPalletDestination IS NULL, 'No', 'Yes') AS isTransformed"
            }],
            "tables": [{
                "Item1": "StockDetail"
            }, {
                "Item1": "Warehouses"
            }, {
                "Item1": "Customers"
            }, {
                "Item1": "Goods"
            }, {
                "Item1": "ListPalletTypes"
            }, {
                "Item1": "InboundsDeliveryNotesDetail"
            }, {
                "Item1": "InboundsDetail"
            }, {
                "Item1": "Inbounds"
            }, {
                "Item1": "TransformationsPalletsDestination"
            }, {
                "Item1": "Transformations"
            }],
            "conditions": [{
                "Item1": "Inbounds",
                "Item2": "code",
                "Item3": "=",
                "Item4": inboundCode,
                "Item5": "AND"
            }, {
                "Item1": "Inbounds",
                "Item2": "deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdOutboundDeliveryNoteDetail",
                "Item3": "IS",
                "Item4": "null",
                "Item5": "AND"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdOutboundDetail",
                "Item3": "IS",
                "Item4": "null",
                "Item5": "AND"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdNoticeOfLossDetail",
                "Item3": "IS",
                "Item4": "null",
                "Item5": "AND"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdWarehouse",
                "Item3": "=",
                "Item4": warehouseId
            }],
            "joins": [{
                "Item1": "StockDetail",
                "Item2": "IdWarehouse",
                "Item3": "Warehouses",
                "Item4": "Id"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdCustomer",
                "Item3": "Customers",
                "Item4": "Id"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdGood",
                "Item3": "Goods",
                "Item4": "Id"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdListPallet",
                "Item3": "ListPalletTypes",
                "Item4": "Id"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdInboundDeliveryNoteDetail",
                "Item3": "InboundsDeliveryNotesDetail",
                "Item4": "Id"
            }, {
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "IdInboundDetail",
                "Item3": "InboundsDetail",
                "Item4": "Id"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "IdInbound",
                "Item3": "Inbounds",
                "Item4": "Id"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdTransformationPalletDestination",
                "Item3": "TransformationsPalletsDestination",
                "Item4": "Id"
            }, {
                "Item1": "TransformationsPalletsDestination",
                "Item2": "IdTransformation",
                "Item3": "Transformations",
                "Item4": "Id"
            }],
            "groupBy": [{
                "Item1": "Warehouses.name"
            }, {
                "Item1": "Customers.name"
            }, {
                "Item1": "Goods.name"
            }, {
                "Item1": "Inbounds.code"
            }, {
                "Item1": "Inbounds.codeDestination"
            }, {
                "Item1": "Inbounds.referenceInboundCode"
            }, {
                "Item1": "ListPalletTypes.name"
            }, {
                "Item1": "StockDetail.idGood"
            }, {
                "Item1": "StockDetail.idCustomer"
            }, {
                "Item1": "StockDetail.idPallet"
            }, {
                "Item1": "StockDetail.location"
            }, {
                "Item1": "StockDetail.totalCases"
            }, {
                "Item1": "StockDetail.goodsPerCase"
            }, {
                "Item1": "StockDetail.totalGoods"
            }, {
                "Item1": "InboundsDetail.bestBeforeDate"
            }, {
                "Item1": "InboundsDeliveryNotesDetail.Id"
            }, {
                "Item1": "StockDetail.IdWarehouse"
            }, {
                "Item1": "InboundsDetail.language"
            }, {
                "Item1": "InboundsDetail.documentation"
            }, {
                "Item1": "StockDetail.IdTransformationPalletDestination"
            }]
        };
        return json;
    }

    private getJsonReadByInboundIdAndWarehouseIdForLabels(inboundId: string) : any {
        const json = {
            "fields": [{
                "Item1": "Customers",
                "Item2": "name as customerName"
            }, {
                "Item1": "Inbounds",
                "Item2": "code as codeInbounds"
            }, {
                "Item1": "Goods",
                "Item2": "id as idGood"
            }, {
                "Item1": "Goods",
                "Item2": "name as goodName"
            }, {
                "Item1": "SUM(StockDetail",
                "Item2": "totalCases) as totalCases"
            }, {
                "Item1": "StockDetail",
                "Item2": "goodsPerCase"
            }, {
                "Item1": "SUM(StockDetail",
                "Item2": "totalGoods) as totalGoods"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "bestBeforeDate"
            }, {
                "Item1": "StockDetail",
                "Item2": "idPallet"
            }, {
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "Id as IdInboundDeliveryNoteDetail"
            }],
            "tables": [{
                "Item1": "StockDetail"
            }, {
                "Item1": "Customers"
            }, {
                "Item1": "Goods"
            }, {
                "Item1": "InboundsDeliveryNotesDetail"
            }, {
                "Item1": "InboundsDetail"
            }, {
                "Item1": "Inbounds"
            }],
            "conditions": [{
                "Item1": "Inbounds",
                "Item2": "id",
                "Item3": "=",
                "Item4": inboundId,
                "Item5": "AND"
            }, {
                "Item1": "Inbounds",
                "Item2": "deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdNoticeOfLossDetail",
                "Item3": "IS",
                "Item4": "null"
            }],
            "joins": [{
                "Item1": "StockDetail",
                "Item2": "IdCustomer",
                "Item3": "Customers",
                "Item4": "Id"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdGood",
                "Item3": "Goods",
                "Item4": "Id"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdInboundDeliveryNoteDetail",
                "Item3": "InboundsDeliveryNotesDetail",
                "Item4": "Id"
            }, {
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "IdInboundDetail",
                "Item3": "InboundsDetail",
                "Item4": "Id"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "IdInbound",
                "Item3": "Inbounds",
                "Item4": "Id"
            }],
            "groupBy": [{
                "Item1": "Customers.name"
            }, {
                "Item1": "Goods.name"
            }, {
                "Item1": "Goods.id"
            }, {
                "Item1": "Inbounds.code"
            }, {
                "Item1": "StockDetail.idPallet"
            }, {
                "Item1": "StockDetail.totalCases"
            }, {
                "Item1": "StockDetail.goodsPerCase"
            }, {
                "Item1": "StockDetail.totalGoods"
            }, {
                "Item1": "InboundsDetail.bestBeforeDate"
            }, {
                "Item1": "InboundsDeliveryNotesDetail.Id"
            }]
        };
        return json;
    }

    private getJsonReadByPalletIds(idSell: string, idCustomer: string) : any {
        const json = {
            "fields": [{
                "Item1": "Warehouses",
                "Item2": "name as warehouseName"
            }, {
                "Item1": "StockDetail",
                "Item2": "idCustomer"
            }, {
                "Item1": "Customers",
                "Item2": "name as customerName"
            }, {
                "Item1": "ISNULL(Inbounds",
                "Item2": "code, (SELECT Code FROM Inbounds WHERE Id IN (SELECT IdInbound FROM Transformations WHERE Id IN (SELECT IdTransformation FROM TransformationsPalletsDestination WHERE Id = StockDetail.IdTransformationPalletDestination)))) as codeInbounds"
            }, {
                "Item1": "Inbounds",
                "Item2": "codeDestination"
            }, {
                "Item1": "Inbounds",
                "Item2": "referenceInboundCode as referenceInboundCode"
            }, {
                "Item1": "ListPalletTypes",
                "Item2": "name as listPalletName"
            }, {
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "Id as IdInboundDeliveryNoteDetail"
            }, {
                "Item1": "Goods",
                "Item2": "name as goodName"
            }, {
                "Item1": "COUNT(DISTINCT(StockDetail",
                "Item2": "IdPallet)) as palletsAmount"
            }, {
                "Item1": "SUM(StockDetail",
                "Item2": "totalCases) as totalCases"
            }, {
                "Item1": "StockDetail",
                "Item2": "goodsPerCase"
            }, {
                "Item1": "SUM(StockDetail",
                "Item2": "totalGoods) as totalGoods"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "bestBeforeDate"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "language"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "documentation"
            }, {
                "Item1": "StockDetail",
                "Item2": "idPallet"
            }, {
                "Item1": "StockDetail",
                "Item2": "location"
            }, {
                "Item1": "StockDetail",
                "Item2": "idGood"
            }, {
                "Item1": "StockDetail",
                "Item2": "idWarehouse"
            }, {
                "Item1": "IIF(StockDetail",
                "Item2": "IdTransformationPalletDestination IS NULL, 'No', 'Yes') AS isTransformed"
            }],
            "tables": [{
                "Item1": "StockDetail"
            }, {
                "Item1": "Warehouses"
            }, {
                "Item1": "Customers"
            }, {
                "Item1": "Goods"
            }, {
                "Item1": "ListPalletTypes"
            }, {
                "Item1": "InboundsDeliveryNotesDetail"
            }, {
                "Item1": "InboundsDetail"
            }, {
                "Item1": "Inbounds"
            }, {
                "Item1": "TransformationsPalletsDestination"
            }, {
                "Item1": "Transformations"
            }],
            "conditions": [{
                "Item1": "StockDetail",
                "Item2": "IdPallet",
                "Item3": "IN",
                "Item4": "(select IdPallet from sellsDetailPallets where idSell = '" + idSell + "' and deleted = 0)",
                "Item5": "AND"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdNoticeOfLossDetail",
                "Item3": "IS",
                "Item4": "null",
                "Item5": "AND"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdCustomer",
                "Item3": "=",
                "Item4": idCustomer,
                "Item5": "AND"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdOutboundDetail",
                "Item3": "IS",
                "Item4": "null"
            }],
            "joins": [{
                "Item1": "StockDetail",
                "Item2": "IdWarehouse",
                "Item3": "Warehouses",
                "Item4": "Id"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdCustomer",
                "Item3": "Customers",
                "Item4": "Id"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdGood",
                "Item3": "Goods",
                "Item4": "Id"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdListPallet",
                "Item3": "ListPalletTypes",
                "Item4": "Id"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdInboundDeliveryNoteDetail",
                "Item3": "InboundsDeliveryNotesDetail",
                "Item4": "Id"
            }, {
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "IdInboundDetail",
                "Item3": "InboundsDetail",
                "Item4": "Id"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "IdInbound",
                "Item3": "Inbounds",
                "Item4": "Id"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdTransformationPalletDestination",
                "Item3": "TransformationsPalletsDestination",
                "Item4": "Id"
            }, {
                "Item1": "TransformationsPalletsDestination",
                "Item2": "IdTransformation",
                "Item3": "Transformations",
                "Item4": "Id"
            }],
            "groupBy": [{
                "Item1": "Warehouses.name"
            }, {
                "Item1": "Customers.name"
            }, {
                "Item1": "Goods.name"
            }, {
                "Item1": "Inbounds.code"
            }, {
                "Item1": "Inbounds.codeDestination"
            }, {
                "Item1": "Inbounds.referenceInboundCode"
            }, {
                "Item1": "ListPalletTypes.name"
            }, {
                "Item1": "StockDetail.idGood"
            }, {
                "Item1": "StockDetail.idCustomer"
            }, {
                "Item1": "StockDetail.idPallet"
            }, {
                "Item1": "StockDetail.location"
            }, {
                "Item1": "StockDetail.totalCases"
            }, {
                "Item1": "StockDetail.goodsPerCase"
            }, {
                "Item1": "StockDetail.totalGoods"
            }, {
                "Item1": "InboundsDetail.bestBeforeDate"
            }, {
                "Item1": "InboundsDeliveryNotesDetail.Id"
            }, {
                "Item1": "StockDetail.IdWarehouse"
            }, {
                "Item1": "InboundsDetail.language"
            }, {
                "Item1": "InboundsDetail.documentation"
            }, {
                "Item1": "StockDetail.IdTransformationPalletDestination"
            }]
        };
        return json;
    }
    private getJsonReadByInboundId(inboundId: string) : any {
        const json = {
            "fields": [{
                "Item1": "Warehouses",
                "Item2": "name as warehouseName"
            }, {
                "Item1": "StockDetail",
                "Item2": "idCustomer"
            }, {
                "Item1": "Customers",
                "Item2": "name as customerName"
            }, {
                "Item1": "ISNULL(Inbounds",
                "Item2": "code, (SELECT Code FROM Inbounds WHERE Id IN (SELECT IdInbound FROM Transformations WHERE Id IN (SELECT IdTransformation FROM TransformationsPalletsDestination WHERE Id = StockDetail.IdTransformationPalletDestination)))) as codeInbounds"
            }, {
                "Item1": "Inbounds",
                "Item2": "codeDestination"
            }, {
                "Item1": "Inbounds",
                "Item2": "referenceInboundCode as referenceInboundCode"
            }, {
                "Item1": "ListPalletTypes",
                "Item2": "name as listPalletName"
            }, {
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "Id as IdInboundDeliveryNoteDetail"
            }, {
                "Item1": "Goods",
                "Item2": "name as goodName"
            }, {
                "Item1": "COUNT(DISTINCT(StockDetail",
                "Item2": "IdPallet)) as palletsAmount"
            }, {
                "Item1": "SUM(StockDetail",
                "Item2": "totalCases) as totalCases"
            }, {
                "Item1": "StockDetail",
                "Item2": "goodsPerCase"
            }, {
                "Item1": "SUM(StockDetail",
                "Item2": "totalGoods) as totalGoods"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "bestBeforeDate as bestBeforeDate"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "language"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "documentation"
            }, {
                "Item1": "StockDetail",
                "Item2": "idPallet"
            }, {
                "Item1": "StockDetail",
                "Item2": "location"
            }, {
                "Item1": "StockDetail",
                "Item2": "idGood"
            }, {
                "Item1": "StockDetail",
                "Item2": "idWarehouse"
            }, {
                "Item1": "IIF(StockDetail",
                "Item2": "IdTransformationPalletDestination IS NULL, 'No', 'Yes') AS isTransformed"
            }],
            "tables": [{
                "Item1": "StockDetail"
            }, {
                "Item1": "Warehouses"
            }, {
                "Item1": "Customers"
            }, {
                "Item1": "Goods"
            }, {
                "Item1": "ListPalletTypes"
            }, {
                "Item1": "InboundsDeliveryNotesDetail"
            }, {
                "Item1": "InboundsDetail"
            }, {
                "Item1": "Inbounds"
            }, {
                "Item1": "TransformationsPalletsDestination"
            }, {
                "Item1": "Transformations"
            }],
            "conditions": [{
                "Item1": "(Inbounds",
                "Item2": "id",
                "Item3": "=",
                "Item4": inboundId,
                "Item5": "OR"
            }, {
                "Item1": "Transformations",
                "Item2": "IdInbound",
                "Item3": "=",
                "Item4": inboundId,
                "Item5": ") AND"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdOutboundDeliveryNoteDetail",
                "Item3": "IS",
                "Item4": "null",
                "Item5": "AND"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdOutboundDetail",
                "Item3": "IS",
                "Item4": "null",
                "Item5": "AND"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdNoticeOfLossDetail",
                "Item3": "IS",
                "Item4": "null"
            }],
            "joins": [{
                "Item1": "StockDetail",
                "Item2": "IdWarehouse",
                "Item3": "Warehouses",
                "Item4": "Id"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdCustomer",
                "Item3": "Customers",
                "Item4": "Id"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdGood",
                "Item3": "Goods",
                "Item4": "Id"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdListPallet",
                "Item3": "ListPalletTypes",
                "Item4": "Id"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdInboundDeliveryNoteDetail",
                "Item3": "InboundsDeliveryNotesDetail",
                "Item4": "Id"
            }, {
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "IdInboundDetail",
                "Item3": "InboundsDetail",
                "Item4": "Id"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "IdInbound",
                "Item3": "Inbounds",
                "Item4": "Id"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdTransformationPalletDestination",
                "Item3": "TransformationsPalletsDestination",
                "Item4": "Id"
            }, {
                "Item1": "TransformationsPalletsDestination",
                "Item2": "IdTransformation",
                "Item3": "Transformations",
                "Item4": "Id"
            }],
            "groupBy": [{
                "Item1": "Warehouses.name"
            }, {
                "Item1": "Customers.name"
            }, {
                "Item1": "Goods.name"
            }, {
                "Item1": "Inbounds.code"
            }, {
                "Item1": "Inbounds.codeDestination"
            }, {
                "Item1": "Inbounds.referenceInboundCode"
            }, {
                "Item1": "ListPalletTypes.name"
            }, {
                "Item1": "StockDetail.idGood"
            }, {
                "Item1": "StockDetail.idCustomer"
            }, {
                "Item1": "StockDetail.idPallet"
            }, {
                "Item1": "StockDetail.location"
            }, {
                "Item1": "StockDetail.totalCases"
            }, {
                "Item1": "StockDetail.goodsPerCase"
            }, {
                "Item1": "StockDetail.totalGoods"
            }, {
                "Item1": "InboundsDetail.bestBeforeDate"
            }, {
                "Item1": "InboundsDeliveryNotesDetail.Id"
            }, {
                "Item1": "StockDetail.IdWarehouse"
            }, {
                "Item1": "InboundsDetail.language"
            }, {
                "Item1": "InboundsDetail.documentation"
            }, {
                "Item1": "StockDetail.IdTransformationPalletDestination"
            }]
        };
        return json;
    }

    private getJsonReadInboundsCodeByCustomerId(idCustomer: string) : any {
        const json = {
            "fields": [{
                "Item1": "Warehouses",
                "Item2": "name as warehouseName"
            }, {
                "Item1": "ISNULL(Inbounds",
                "Item2": "code, (SELECT Code FROM Inbounds WHERE Id IN (SELECT IdInbound FROM Transformations WHERE Id IN (SELECT IdTransformation FROM TransformationsPalletsDestination WHERE Id = StockDetail.IdTransformationPalletDestination)))) as codeInbounds"
            }, {
                "Item1": "Inbounds",
                "Item2": "codeDestination"
            }, {
                "Item1": "StockDetail",
                "Item2": "idCustomer"
            }, {
                "Item1": "StockDetail",
                "Item2": "idCompanySource"
            }, {
                "Item1": "StockDetail",
                "Item2": "idCompanyDestination"
            }, {
                "Item1": "Inbounds",
                "Item2": "id as idInbound"
            }, {
                "Item1": "StockDetail",
                "Item2": "dateIn"
            }],
            "tables": [{
                "Item1": "StockDetail"
            }, {
                "Item1": "Warehouses"
            }, {
                "Item1": "InboundsDeliveryNotesDetail"
            }, {
                "Item1": "InboundsDetail"
            }, {
                "Item1": "Inbounds"
            }],
            "conditions": [{
                "Item1": "StockDetail",
                "Item2": "IdOutboundDeliveryNoteDetail",
                "Item3": "IS",
                "Item4": "null",
                "Item5": "AND"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdOutboundDetail",
                "Item3": "IS",
                "Item4": "null",
                "Item5": "AND"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdNoticeOfLossDetail",
                "Item3": "IS",
                "Item4": "null",
                "Item5": "AND"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdCustomer",
                "Item3": "=",
                "Item4": idCustomer
            }],
            "joins": [{
                "Item1": "StockDetail",
                "Item2": "IdWarehouse",
                "Item3": "Warehouses",
                "Item4": "Id"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdInboundDeliveryNoteDetail",
                "Item3": "InboundsDeliveryNotesDetail",
                "Item4": "Id"
            }, {
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "IdInboundDetail",
                "Item3": "InboundsDetail",
                "Item4": "Id"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "IdInbound",
                "Item3": "Inbounds",
                "Item4": "Id"
            }],
            "groupBy": [{
                "Item1": "Warehouses.name"
            }, {
                "Item1": "Inbounds.code"
            }, {
                "Item1": "Inbounds.codeDestination"
            }, {
                "Item1": "Inbounds.id"
            }, {
                "Item1": "StockDetail.dateIn"
            }, {
                "Item1": "StockDetail.idCustomer"
            }, {
                "Item1": "StockDetail.idCompanySource"
            }, {
                "Item1": "StockDetail.idCompanyDestination"
            }, {
                "Item1": "StockDetail.IdTransformationPalletDestination"
            }]
        };
        return json;
    }

    private getJsonReadInboundsCodeInStock(idCompany: string) : any {
        const json = {
            "fields": [{
                "Item1": "Warehouses",
                "Item2": "name as warehouseName"
            }, {
                "Item1": "ISNULL(Inbounds",
                "Item2": "code, (SELECT Code FROM Inbounds WHERE Id IN (SELECT IdInbound FROM Transformations WHERE Id IN (SELECT IdTransformation FROM TransformationsPalletsDestination WHERE Id = StockDetail.IdTransformationPalletDestination)))) as codeInbounds"
            }, {
                "Item1": "Inbounds",
                "Item2": "codeDestination"
            }, {
                "Item1": "StockDetail",
                "Item2": "idCustomer"
            }, {
                "Item1": "StockDetail",
                "Item2": "idCompanySource"
            }, {
                "Item1": "StockDetail",
                "Item2": "idCompanyDestination"
            }, {
                "Item1": "Inbounds",
                "Item2": "id as idInbound"
            }, {
                "Item1": "StockDetail",
                "Item2": "dateIn"
            }, {
                "Item1": "Warehouses",
                "Item2": "id as idWarehouse"
            }, {
                "Item1": "Customers",
                "Item2": "name as customerName"
            }],
            "tables": [{
                "Item1": "StockDetail"
            }, {
                "Item1": "Warehouses"
            }, {
                "Item1": "InboundsDeliveryNotesDetail"
            }, {
                "Item1": "InboundsDetail"
            }, {
                "Item1": "Inbounds"
            }, {
                "Item1": "Customers"
            }],
            "conditions": [{
                "Item1": "StockDetail",
                "Item2": "IdOutboundDeliveryNoteDetail",
                "Item3": "IS",
                "Item4": "null",
                "Item5": "AND"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdOutboundDetail",
                "Item3": "IS",
                "Item4": "null",
                "Item5": "AND"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdNoticeOfLossDetail",
                "Item3": "IS",
                "Item4": "null",
                "Item5": "AND"
            }, {
                "Item1": "(Inbounds",
                "Item2": "idCompanySource",
                "Item3": "=",
                "Item4": idCompany,
                "Item5": "OR"
            }, {
                "Item1": "Inbounds",
                "Item2": "idCompanyDestination",
                "Item3": "=",
                "Item4": idCompany,
                "Item5": ")"
            }],
            "joins": [{
                "Item1": "StockDetail",
                "Item2": "IdWarehouse",
                "Item3": "Warehouses",
                "Item4": "Id"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdInboundDeliveryNoteDetail",
                "Item3": "InboundsDeliveryNotesDetail",
                "Item4": "Id"
            }, {
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "IdInboundDetail",
                "Item3": "InboundsDetail",
                "Item4": "Id"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "IdInbound",
                "Item3": "Inbounds",
                "Item4": "Id"
            }, {
                "Item1": "Inbounds",
                "Item2": "idCustomer",
                "Item3": "Customers",
                "Item4": "Id"
            }],
            "groupBy": [{
                "Item1": "Warehouses.name"
            }, {
                "Item1": "Inbounds.code"
            }, {
                "Item1": "Inbounds.id"
            }, {
                "Item1": "Inbounds.codeDestination"
            }, {
                "Item1": "StockDetail.dateIn"
            }, {
                "Item1": "StockDetail.idCustomer"
            }, {
                "Item1": "StockDetail.idCompanySource"
            }, {
                "Item1": "StockDetail.idCompanyDestination"
            }, {
                "Item1": "StockDetail.IdTransformationPalletDestination"
            }, {
                "Item1": "Warehouses.id"
            }, {
                "Item1": "Customers.name"
            }]
        };
        return json;
    }

    private getJsonReadGroupByWarehousesIds(idWarehouses: string[], idCompany: string) : any {
        let ids = this.getConcatIds(idWarehouses);
        const today = new Date().toISOString().substring(0, 10);
        const json = {
            "fields": [{
                "Item1": "Warehouses",
                "Item2": "id as idWarehouse"
            }, {
                "Item1": "Warehouses",
                "Item2": "name as warehouseName"
            }, {
                "Item1": "StockDetail",
                "Item2": "idCustomer"
            }, {
                "Item1": "Customers",
                "Item2": "name as customerName"
            }, {
                "Item1": "ISNULL(Inbounds",
                "Item2": "code, (SELECT Code FROM Inbounds WHERE Id IN (SELECT IdInbound FROM Transformations WHERE Id IN (SELECT IdTransformation FROM TransformationsPalletsDestination WHERE Id = StockDetail.IdTransformationPalletDestination)))) as codeInbounds"
            }, {
                "Item1": "Inbounds",
                "Item2": "codeDestination"
            }, {
                "Item1": "Inbounds",
                "Item2": "referenceInboundCode as referenceInboundCode"
            }, {
                "Item1": "Goods",
                "Item2": "name as goodName"
            }, {
                "Item1": "ListPalletTypes",
                "Item2": "name as listPalletName"
            }, {
                "Item1": "StockDetail",
                "Item2": "idPallet"
            }, {
                "Item1": "SUM(StockDetail",
                "Item2": "totalCases) as totalCases"
            }, {
                "Item1": "StockDetail",
                "Item2": "goodsPerCase"
            }, {
                "Item1": "SUM(StockDetail",
                "Item2": "totalGoods) as totalGoods"
            }, {
                "Item1": "format(StockDetail",
                "Item2": "dateIn, 'dd/MM/yyyy') as dateIn"
            }, {
                "Item1": "format(StockDetail",
                "Item2": "dateOut, 'dd/MM/yyyy') as dateOut"
            }, {
                "Item1": "StockDetail",
                "Item2": "location"
            }, {
                "Item1": "format(InboundsDetail",
                "Item2": "bestBeforeDate, 'dd/MM/yyyy') as bestBeforeDate"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "language"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "documentation"
            }, {
                "Item1": "IIF(StockDetail",
                "Item2": "IdTransformationPalletDestination IS NULL, 'No', 'Yes') AS isTransformed"
            }, {
                "Item1": "StockDetail",
                "Item2": "idCompanySource"
            }, {
                "Item1": "StockDetail",
                "Item2": "idCompanyDestination"
            }, {
                "Item1": "Companies",
                "Item2": "name as companySourceName"
            }, {
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "weight as weight"
            }, {
                "Item1": "SCAN_StockDetailScan",
                "Item2": "IdPalletCustomer"
            }, {
                "Item1": "Goods",
                "Item2": "code as goodCode"
            }],
            "tables": [{
                "Item1": "StockDetail"
            }, {
                "Item1": "Warehouses"
            }, {
                "Item1": "Customers"
            }, {
                "Item1": "Goods"
            }, {
                "Item1": "ListPalletTypes"
            }, {
                "Item1": "InboundsDeliveryNotesDetail"
            }, {
                "Item1": "InboundsDetail"
            }, {
                "Item1": "Inbounds"
            }, {
                "Item1": "Companies"
            }, {
                "Item1": "SCAN_StockDetailScan"
            }],
            "conditions": [{
                "Item1": "StockDetail",
                "Item2": "idWarehouse",
                "Item3": "IN",
                "Item4": ids,
                "Item5": "AND"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdOutboundDeliveryNoteDetail",
                "Item3": "IS",
                "Item4": "null",
                "Item5": "AND"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdOutboundDetail",
                "Item3": "IS",
                "Item4": "null",
                "Item5": "AND"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdNoticeOfLossDetail",
                "Item3": "IS",
                "Item4": "null",
                "Item5": "AND"
            }, {
                "Item1": "(StockDetail",
                "Item2": "IdCompanySource",
                "Item3": "=",
                "Item4": idCompany,
                "Item5": "OR"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdCompanyDestination",
                "Item3": "=",
                "Item4": idCompany,
                "Item5": ")"
            }],
            "joins": [{
                "Item1": "StockDetail",
                "Item2": "IdWarehouse",
                "Item3": "Warehouses",
                "Item4": "Id"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdCustomer",
                "Item3": "Customers",
                "Item4": "Id"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdGood",
                "Item3": "Goods",
                "Item4": "Id"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdListPallet",
                "Item3": "ListPalletTypes",
                "Item4": "Id"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdInboundDeliveryNoteDetail",
                "Item3": "InboundsDeliveryNotesDetail",
                "Item4": "Id"
            }, {
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "IdInboundDetail",
                "Item3": "InboundsDetail",
                "Item4": "Id"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "IdInbound",
                "Item3": "Inbounds",
                "Item4": "Id"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdCompanySource",
                "Item3": "Companies",
                "Item4": "Id"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdPallet",
                "Item3": "SCAN_StockDetailScan",
                "Item4": "IdPallet"
            }],
            "groupBy": [{
                "Item1": "Warehouses.id"
            }, {
                "Item1": "Warehouses.name"
            }, {
                "Item1": "Customers.name"
            }, {
                "Item1": "Goods.name"
            }, {
                "Item1": "Inbounds.code"
            }, {
                "Item1": "Inbounds.codeDestination"
            }, {
                "Item1": "Inbounds.referenceInboundCode"
            }, {
                "Item1": "StockDetail.idPallet"
            }, {
                "Item1": "ListPalletTypes.name"
            }, {
                "Item1": "StockDetail.totalCases"
            }, {
                "Item1": "StockDetail.goodsPerCase"
            }, {
                "Item1": "StockDetail.totalGoods"
            }, {
                "Item1": "StockDetail.idCustomer"
            }, {
                "Item1": "StockDetail.dateIn"
            }, {
                "Item1": "StockDetail.dateOut"
            }, {
                "Item1": "StockDetail.location"
            }, {
                "Item1": "InboundsDetail.bestBeforeDate"
            }, {
                "Item1": "InboundsDetail.language"
            }, {
                "Item1": "InboundsDeliveryNotesDetail.weight"
            }, {
                "Item1": "InboundsDetail.documentation"
            }, {
                "Item1": "StockDetail.IdTransformationPalletDestination"
            }, {
                "Item1": "Companies.name"
            }, {
                "Item1": "StockDetail.IdCompanySource"
            }, {
                "Item1": "StockDetail.IdCompanyDestination"
            }, {
                "Item1": "SCAN_StockDetailScan.IdPalletCustomer"
            }, {
                "Item1": "Goods.Code"
            }],
            "orderBy": [{
                "Item1": "Goods.name"
            }, {
                "Item1": "StockDetail.IdPallet"
            }]

        };
        return json;
    }

    private getJsonReadGroupByWarehousesIdsWithScanner(idWarehouses: string[], idCompany: string) : any {
        let ids = this.getConcatIds(idWarehouses);
        const today = new Date().toISOString().substring(0, 10);
        const json = {
            "fields": [{
                "Item1": "Warehouses",
                "Item2": "id as idWarehouse"
            }, {
                "Item1": "Warehouses",
                "Item2": "name as warehouseName"
            }, {
                "Item1": "StockDetail",
                "Item2": "idCustomer"
            }, {
                "Item1": "Customers",
                "Item2": "name as customerName"
            }, {
                "Item1": "ISNULL(Inbounds",
                "Item2": "code, (SELECT Code FROM Inbounds WHERE Id IN (SELECT IdInbound FROM Transformations WHERE Id IN (SELECT IdTransformation FROM TransformationsPalletsDestination WHERE Id = StockDetail.IdTransformationPalletDestination)))) as codeInbounds"
            }, {
                "Item1": "Inbounds",
                "Item2": "codeDestination"
            }, {
                "Item1": "Inbounds",
                "Item2": "referenceInboundCode as referenceInboundCode"
            }, {
                "Item1": "Goods",
                "Item2": "name as goodName"
            }, {
                "Item1": "ListPalletTypes",
                "Item2": "name as listPalletName"
            }, {
                "Item1": "StockDetail",
                "Item2": "idPallet"
            }, {
                "Item1": "SUM(StockDetail",
                "Item2": "totalCases) as totalCases"
            }, {
                "Item1": "StockDetail",
                "Item2": "goodsPerCase"
            }, {
                "Item1": "SUM(StockDetail",
                "Item2": "totalGoods) as totalGoods"
            }, {
                "Item1": "format(StockDetail",
                "Item2": "dateIn, 'dd/MM/yyyy') as dateIn"
            }, {
                "Item1": "format(StockDetail",
                "Item2": "dateOut, 'dd/MM/yyyy') as dateOut"
            }, {
                "Item1": "StockDetail",
                "Item2": "location"
            }, {
                "Item1": "format(InboundsDetail",
                "Item2": "bestBeforeDate, 'dd/MM/yyyy') as bestBeforeDate"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "language"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "documentation"
            }, {
                "Item1": "IIF(StockDetail",
                "Item2": "IdTransformationPalletDestination IS NULL, 'No', 'Yes') AS isTransformed"
            }, {
                "Item1": "StockDetail",
                "Item2": "idCompanySource"
            }, {
                "Item1": "StockDetail",
                "Item2": "idCompanyDestination"
            }, {
                "Item1": "Companies",
                "Item2": "name as companySourceName"
            }, {
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "weight as weight"
            }, {
                "Item1": "SCAN_StockDetailScan",
                "Item2": "IdPalletCustomer"
            }, {
                "Item1": "Inbounds",
                "Item2": "id as idInbound"
            }, {
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "id as idInboundDeliveryNoteDetail"
            }],
            "tables": [{
                "Item1": "StockDetail"
            }, {
                "Item1": "Warehouses"
            }, {
                "Item1": "Customers"
            }, {
                "Item1": "Goods"
            }, {
                "Item1": "ListPalletTypes"
            }, {
                "Item1": "InboundsDeliveryNotesDetail"
            }, {
                "Item1": "InboundsDetail"
            }, {
                "Item1": "Inbounds"
            }, {
                "Item1": "Companies"
            }, {
                "Item1": "SCAN_StockDetailScan"
            }],
            "conditions": [{
                "Item1": "StockDetail",
                "Item2": "idWarehouse",
                "Item3": "IN",
                "Item4": ids,
                "Item5": "AND"
            }, {
                "Item1": "((StockDetail",
                "Item2": "IdOutboundDeliveryNoteDetail",
                "Item3": "IS",
                "Item4": "null",
                "Item5": "AND"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdOutboundDetail",
                "Item3": "IS",
                "Item4": "null",
                "Item5": "AND"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdNoticeOfLossDetail",
                "Item3": "IS",
                "Item4": "null",
                "Item5": ") OR"
            }, {
                "Item1": "StockDetail",
                "Item2": "dateOut",
                "Item3": ">=",
                "Item4": today,
                "Item5": ") AND"
            }, {
                "Item1": "(StockDetail",
                "Item2": "IdCompanySource",
                "Item3": "=",
                "Item4": idCompany,
                "Item5": "OR"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdCompanyDestination",
                "Item3": "=",
                "Item4": idCompany,
                "Item5": ")"
            }],
            "joins": [{
                "Item1": "StockDetail",
                "Item2": "IdWarehouse",
                "Item3": "Warehouses",
                "Item4": "Id"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdCustomer",
                "Item3": "Customers",
                "Item4": "Id"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdGood",
                "Item3": "Goods",
                "Item4": "Id"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdListPallet",
                "Item3": "ListPalletTypes",
                "Item4": "Id"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdInboundDeliveryNoteDetail",
                "Item3": "InboundsDeliveryNotesDetail",
                "Item4": "Id"
            }, {
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "IdInboundDetail",
                "Item3": "InboundsDetail",
                "Item4": "Id"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "IdInbound",
                "Item3": "Inbounds",
                "Item4": "Id"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdCompanySource",
                "Item3": "Companies",
                "Item4": "Id"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdPallet",
                "Item3": "SCAN_StockDetailScan",
                "Item4": "IdPallet"
            }],
            "groupBy": [{
                "Item1": "Warehouses.id"
            }, {
                "Item1": "Warehouses.name"
            }, {
                "Item1": "Customers.name"
            }, {
                "Item1": "Goods.name"
            }, {
                "Item1": "Inbounds.code"
            }, {
                "Item1": "Inbounds.codeDestination"
            }, {
                "Item1": "Inbounds.referenceInboundCode"
            }, {
                "Item1": "StockDetail.idPallet"
            }, {
                "Item1": "ListPalletTypes.name"
            }, {
                "Item1": "StockDetail.totalCases"
            }, {
                "Item1": "StockDetail.goodsPerCase"
            }, {
                "Item1": "StockDetail.totalGoods"
            }, {
                "Item1": "StockDetail.idCustomer"
            }, {
                "Item1": "StockDetail.dateIn"
            }, {
                "Item1": "StockDetail.dateOut"
            }, {
                "Item1": "StockDetail.location"
            }, {
                "Item1": "InboundsDetail.bestBeforeDate"
            }, {
                "Item1": "InboundsDetail.language"
            }, {
                "Item1": "InboundsDeliveryNotesDetail.weight"
            }, {
                "Item1": "InboundsDetail.documentation"
            }, {
                "Item1": "StockDetail.IdTransformationPalletDestination"
            }, {
                "Item1": "Companies.name"
            }, {
                "Item1": "StockDetail.IdCompanySource"
            }, {
                "Item1": "StockDetail.IdCompanyDestination"
            }, {
                "Item1": "SCAN_StockDetailScan.IdPalletCustomer"
            }, {
                "Item1": "Inbounds.id"
            }, {
                "Item1": "InboundsDeliveryNotesDetail.id"
            }],
            "orderBy": [{
                "Item1": "Goods.name"
            }, {
                "Item1": "StockDetail.IdPallet"
            }]

        };
        return json;
    }

    private getJsonReadGroupByGoods(idGoods: string[], idInboundsDeliveryNoteDetails: string[]) : any {
        let idGood = this.getConcatIds(idGoods);
        let idInboundsDeliveryNote = this.getConcatIds(idInboundsDeliveryNoteDetails);
        const json = {
            "fields": [{
                "Item1": "StockDetail",
                "Item2": "idWarehouse"
            }, {
                "Item1": "Warehouses",
                "Item2": "name as warehouseName"
            }, {
                "Item1": "StockDetail",
                "Item2": "idCustomer"
            }, {
                "Item1": "Customers",
                "Item2": "name as customerName"
            }, {
                "Item1": "ISNULL(Inbounds",
                "Item2": "code, (SELECT Code FROM Inbounds WHERE Id IN (SELECT IdInbound FROM Transformations WHERE Id IN (SELECT IdTransformation FROM TransformationsPalletsDestination WHERE Id = StockDetail.IdTransformationPalletDestination)))) as codeInbounds"
            }, {
                "Item1": "Inbounds",
                "Item2": "codeDestination"
            }, {
                "Item1": "Inbounds",
                "Item2": "referenceInboundCode as referenceInboundCode"
            }, {
                "Item1": "Goods",
                "Item2": "name as goodName"
            }, {
                "Item1": "Goods",
                "Item2": "code as goodCode"
            }, {
                "Item1": "StockDetail",
                "Item2": "idListPallet"
            }, {
                "Item1": "ListPalletTypes",
                "Item2": "name as listPalletName"
            }, {
                "Item1": "StockDetail",
                "Item2": "idPallet"
            }, {
                "Item1": "SUM(StockDetail",
                "Item2": "totalCases) as totalCases"
            }, {
                "Item1": "StockDetail",
                "Item2": "goodsPerCase"
            }, {
                "Item1": "SUM(StockDetail",
                "Item2": "totalGoods) as totalGoods"
            }, {
                "Item1": "format(StockDetail",
                "Item2": "dateIn, 'dd/MM/yyyy') as dateIn"
            }, {
                "Item1": "format(StockDetail",
                "Item2": "dateOut, 'dd/MM/yyyy') as dateOut"
            }, {
                "Item1": "StockDetail",
                "Item2": "location"
            }, {
                "Item1": "StockDetail",
                "Item2": "idInboundDeliveryNoteDetail"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "bestBeforeDate"
            }, {
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "weight"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "language"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "documentation"
            }, {
                "Item1": "IIF(StockDetail",
                "Item2": "IdTransformationPalletDestination IS NULL, 'No', 'Yes') AS isTransformed"
            }, {
                "Item1": "StockDetail",
                "Item2": "idGood"
            }, {
                "Item1": "SCAN_StockDetailScan",
                "Item2": "IdPalletCustomer"
            }],
            "tables": [{
                "Item1": "StockDetail"
            }, {
                "Item1": "Warehouses"
            }, {
                "Item1": "Customers"
            }, {
                "Item1": "Goods"
            }, {
                "Item1": "ListPalletTypes"
            }, {
                "Item1": "InboundsDeliveryNotesDetail"
            }, {
                "Item1": "InboundsDetail"
            }, {
                "Item1": "Inbounds"
            }, {
                "Item1": "SCAN_StockDetailScan"
            }],
            "conditions": [{
                "Item1": "StockDetail",
                "Item2": "idGood",
                "Item3": "IN",
                "Item4": idGood,
                "Item5": "AND"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdOutboundDeliveryNoteDetail",
                "Item3": "IS",
                "Item4": "null",
                "Item5": "AND"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdOutboundDetail",
                "Item3": "IS",
                "Item4": "null",
                "Item5": "AND"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdNoticeOfLossDetail",
                "Item3": "IS",
                "Item4": "null",
                "Item5": "AND"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdPallet",
                "Item3": "NOT IN",
                "Item4": "(SELECT IdPallet FROM SellsDetailPallets WHERE Deleted = 0 AND SellsDetailPallets.IdInboundDeliveryNoteDetail = StockDetail.IdInboundDeliveryNoteDetail)",
                "Item5": "AND"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdInboundDeliveryNoteDetail",
                "Item3": "IN",
                "Item4": idInboundsDeliveryNote
            }],
            "joins": [{
                "Item1": "StockDetail",
                "Item2": "IdWarehouse",
                "Item3": "Warehouses",
                "Item4": "Id"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdCustomer",
                "Item3": "Customers",
                "Item4": "Id"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdGood",
                "Item3": "Goods",
                "Item4": "Id"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdListPallet",
                "Item3": "ListPalletTypes",
                "Item4": "Id"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdInboundDeliveryNoteDetail",
                "Item3": "InboundsDeliveryNotesDetail",
                "Item4": "Id"
            }, {
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "IdInboundDetail",
                "Item3": "InboundsDetail",
                "Item4": "Id"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "IdInbound",
                "Item3": "Inbounds",
                "Item4": "Id"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdPallet",
                "Item3": "SCAN_StockDetailScan",
                "Item4": "IdPallet"
            }],
            "groupBy": [{
                "Item1": "StockDetail.idWarehouse"
            }, {
                "Item1": "Warehouses.name"
            }, {
                "Item1": "Customers.name"
            }, {
                "Item1": "Goods.name"
            }, {
                "Item1": "Goods.code"
            }, {
                "Item1": "Inbounds.code"
            }, {
                "Item1": "Inbounds.codeDestination"
            }, {
                "Item1": "Inbounds.referenceInboundCode"
            }, {
                "Item1": "StockDetail.idPallet"
            }, {
                "Item1": "StockDetail.idListPallet"
            }, {
                "Item1": "ListPalletTypes.name"
            }, {
                "Item1": "StockDetail.totalCases"
            }, {
                "Item1": "StockDetail.idCustomer"
            }, {
                "Item1": "StockDetail.goodsPerCase"
            }, {
                "Item1": "StockDetail.totalGoods"
            }, {
                "Item1": "StockDetail.dateIn"
            }, {
                "Item1": "StockDetail.dateOut"
            }, {
                "Item1": "StockDetail.location"
            }, {
                "Item1": "InboundsDetail.bestBeforeDate"
            }, {
                "Item1": "StockDetail.idInboundDeliveryNoteDetail"
            }, {
                "Item1": "InboundsDeliveryNotesDetail.weight"
            }, {
                "Item1": "InboundsDetail.language"
            }, {
                "Item1": "InboundsDetail.documentation"
            }, {
                "Item1": "StockDetail.IdTransformationPalletDestination"
            }, {
                "Item1": "StockDetail.IdGood"
            }, {
                "Item1": "SCAN_StockDetailScan.IdPalletCustomer"
            }]
        };
        return json;
    }

    private getJsonReadGroupByPallets(idWarehouses: string[]) : any {
        let ids = this.getConcatIds(idWarehouses);
        const json = {
            "fields": [{
                "Item1": "Warehouses",
                "Item2": "id as idWarehouse"
            }, {
                "Item1": "Warehouses",
                "Item2": "name as warehouseName"
            }, {
                "Item1": "StockDetail",
                "Item2": "idCustomer"
            }, {
                "Item1": "Customers",
                "Item2": "name as customerName"
            }, {
                "Item1": "ISNULL(Inbounds",
                "Item2": "code, (SELECT Code FROM Inbounds WHERE Id IN (SELECT IdInbound FROM Transformations WHERE Id IN (SELECT IdTransformation FROM TransformationsPalletsDestination WHERE Id = StockDetail.IdTransformationPalletDestination)))) as codeInbounds"
            }, {
                "Item1": "Inbounds",
                "Item2": "codeDestination"
            }, {
                "Item1": "Inbounds",
                "Item2": "referenceInboundCode as referenceInboundCode"
            }, {
                "Item1": "Goods",
                "Item2": "name as goodName"
            }, {
                "Item1": "Goods",
                "Item2": "code as goodCode"
            }, {
                "Item1": "ListPalletTypes",
                "Item2": "name as listPalletName"
            }, {
                "Item1": "COUNT(DISTINCT(StockDetail",
                "Item2": "idPallet)) as palletsAmount"
            }, {
                "Item1": "SUM(StockDetail",
                "Item2": "totalCases) as totalCases"
            }, {
                "Item1": "StockDetail",
                "Item2": "goodsPerCase"
            }, {
                "Item1": "SUM(StockDetail",
                "Item2": "totalGoods) as totalGoods"
            }, {
                "Item1": "format(StockDetail",
                "Item2": "dateIn, 'dd/MM/yyyy') as dateIn"
            }, {
                "Item1": "format(StockDetail",
                "Item2": "dateOut, 'dd/MM/yyyy') as dateOut"
            }, {
                "Item1": "StockDetail",
                "Item2": "location"
            }, {
                "Item1": "format(InboundsDetail",
                "Item2": "bestBeforeDate, 'dd/MM/yyyy') as bestBeforeDate"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "language"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "documentation"
            }, {
                "Item1": "IIF(StockDetail",
                "Item2": "IdTransformationPalletDestination IS NULL, 'No', 'Yes') AS isTransformed"
            }, {
                "Item1": "StockDetail",
                "Item2": "idCompanySource"
            }, {
                "Item1": "StockDetail",
                "Item2": "idCompanyDestination"
            }, {
                "Item1": "Companies",
                "Item2": "name as companySourceName"
            }],
            "tables": [{
                "Item1": "StockDetail"
            }, {
                "Item1": "Warehouses"
            }, {
                "Item1": "Customers"
            }, {
                "Item1": "Goods"
            }, {
                "Item1": "ListPalletTypes"
            }, {
                "Item1": "InboundsDeliveryNotesDetail"
            }, {
                "Item1": "InboundsDetail"
            }, {
                "Item1": "Inbounds"
            }, {
                "Item1": "Companies"
            }],
            "conditions": [{
                "Item1": "StockDetail",
                "Item2": "idWarehouse",
                "Item3": "IN",
                "Item4": ids,
                "Item5": "AND"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdOutboundDeliveryNoteDetail",
                "Item3": "IS",
                "Item4": "null",
                "Item5": "AND"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdOutboundDetail",
                "Item3": "IS",
                "Item4": "null",
                "Item5": "AND"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdNoticeOfLossDetail",
                "Item3": "IS",
                "Item4": "null"
            }],
            "joins": [{
                "Item1": "StockDetail",
                "Item2": "IdWarehouse",
                "Item3": "Warehouses",
                "Item4": "Id"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdCustomer",
                "Item3": "Customers",
                "Item4": "Id"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdGood",
                "Item3": "Goods",
                "Item4": "Id"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdListPallet",
                "Item3": "ListPalletTypes",
                "Item4": "Id"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdInboundDeliveryNoteDetail",
                "Item3": "InboundsDeliveryNotesDetail",
                "Item4": "Id"
            }, {
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "IdInboundDetail",
                "Item3": "InboundsDetail",
                "Item4": "Id"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "IdInbound",
                "Item3": "Inbounds",
                "Item4": "Id"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdCompanySource",
                "Item3": "Companies",
                "Item4": "Id"
            }],
            "groupBy": [{
                "Item1": "Warehouses.id"
            }, {
                "Item1": "Warehouses.name"
            }, {
                "Item1": "Customers.name"
            }, {
                "Item1": "Goods.name"
            }, {
                "Item1": "Goods.code"
            }, {
                "Item1": "Inbounds.codeDestination"
            }, {
                "Item1": "Inbounds.code"
            }, {
                "Item1": "Inbounds.referenceInboundCode"
            }, {
                "Item1": "ListPalletTypes.name"
            }, {
                "Item1": "StockDetail.totalCases"
            }, {
                "Item1": "StockDetail.idCustomer"
            }, {
                "Item1": "StockDetail.goodsPerCase"
            }, {
                "Item1": "StockDetail.totalGoods"
            }, {
                "Item1": "StockDetail.dateIn"
            }, {
                "Item1": "StockDetail.dateOut"
            }, {
                "Item1": "StockDetail.location"
            }, {
                "Item1": "InboundsDetail.bestBeforeDate"
            }, {
                "Item1": "InboundsDetail.language"
            }, {
                "Item1": "InboundsDetail.documentation"
            }, {
                "Item1": "StockDetail.IdTransformationPalletDestination"
            }, {
                "Item1": "Companies.name"
            }, {
                "Item1": "StockDetail.IdCompanySource"
            }, {
                "Item1": "StockDetail.IdCompanyDestination"
            }]
        };
        return json;
    }

    private getJsonReadGroupByPalletsAndCustomer(idCustomer: string): any {
        const json = {
            "fields": [{
                "Item1": "*, (B.PalletsAmount - B.PalletsAmountSell) AS AvailablePalletsAmountFinal, (B.AvailableCases - B.SellCases) AS AvailableCasesFinal, (B.AvailableGoods - B.SellGoods) AS AvailableGoodsFinal  " +
                    "FROM (SELECT " +
                    "A.IdCompanyDestination, " +
                    "A.IdWarehouse, " +
                    "A.IdCustomer, " +
                    "A.warehouseName, A.customerName, A.codeInbounds, A.codeDestination, A.dateIn, A.idInbound, A.IdInboundDeliveryNoteDetail, A.referenceInboundCode, " +
                    "A.idGood, A.idListPallet, A.goodName, A.goodCode, A.sku, A.listPalletName, " +
                    "SUM(A.palletsAmount) AS palletsAmount, " +
                    "SUM(A.totalCases) AS totalCases, " +
                    "SUM(A.AllocatedCases) AS AllocatedCases, " +
                    "SUM(A.AvailableCases) AS AvailableCases, " +
                    "A.goodsPerCase, " +
                    "SUM(A.totalGoods) AS totalGoods, " +
                    "SUM(A.AllocatedGoods) AS AllocatedGoods, " +
                    "SUM(A.AvailableGoods) AS AvailableGoods, " +
                    "A.bestBeforeDate, A.weight, A.language, A.documentation, " +
                    "A.IdPalletCustomer, " + // ✅ Añadido para que aparezca en el resultado final
                    "STUFF((SELECT DISTINCT ' | ' + SD2.Location " +
                    "FROM StockDetail SD2 " +
                    "WHERE SD2.IdInboundDeliveryNoteDetail = A.IdInboundDeliveryNoteDetail " +
                    "AND SD2.IdWarehouse = A.IdWarehouse " +
                    "AND SD2.IdGood = A.IdGood " +
                    "AND SD2.IdListPallet = A.IdListPallet " +
                    "AND SD2.IdCustomer = A.IdCustomer " +
                    "AND SD2.IdOutboundDeliveryNoteDetail IS NULL " +
                    "AND SD2.IdOutboundDetail IS NULL " +
                    "AND SD2.IdNoticeOfLossDetail IS NULL " +
                    "FOR XML PATH(''), TYPE).value('.', 'NVARCHAR(MAX)'), 1, 3, '') AS location, " +
                    "ISNULL((SELECT SUM(SellsDetail.PalletsAmount) " +
                    "FROM SellsDetail LEFT OUTER JOIN Sells ON (SellsDetail.IdSell = Sells.Id) " +
                    "WHERE IdGood = A.IdGood AND IdInbound = A.IdInbound AND IdListPallet = A.IdListPallet " +
                    "AND CasesAmountPallet = (A.TotalCases / A.PalletsAmount) " +
                    "AND SellsDetail.Deleted = 0 " + SELL_STATUS_EXCLUDED_SQL_FILTER + "), 0) AS palletsAmountSell, " +
                    "ISNULL((SELECT SUM(SellsDetail.CasesAmountPallet) * SUM(SellsDetail.PalletsAmount) " +
                    "FROM SellsDetail LEFT OUTER JOIN Sells ON (SellsDetail.IdSell = Sells.Id) " +
                    "WHERE IdGood = A.IdGood AND IdInbound = A.IdInbound AND IdListPallet = A.IdListPallet " +
                    "AND CasesAmountPallet = (A.TotalCases / A.PalletsAmount) " +
                    "AND SellsDetail.Deleted = 0 " + SELL_STATUS_EXCLUDED_SQL_FILTER + "), 0) AS sellCases, " +
                    "ISNULL((SELECT SUM(SellsDetail.GoodsPerCase) * SUM(SellsDetail.CasesAmountPallet) * SUM(SellsDetail.PalletsAmount) " +
                    "FROM SellsDetail LEFT OUTER JOIN Sells ON (SellsDetail.IdSell = Sells.Id) " +
                    "WHERE IdGood = A.IdGood AND IdInbound = A.IdInbound AND IdListPallet = A.IdListPallet " +
                    "AND CasesAmountPallet = (A.TotalCases / A.PalletsAmount) " +
                    "AND SellsDetail.Deleted = 0 " + SELL_STATUS_EXCLUDED_SQL_FILTER + "), 0) AS sellGoods " +
                    "FROM (SELECT Warehouses",
                "Item2": "name as warehouseName"
            }, {
                "Item1": "StockDetail",
                "Item2": "idCustomer"
            }, {
                "Item1": "Customers",
                "Item2": "name as customerName"
            }, {
                "Item1": "ISNULL(Inbounds",
                "Item2": "code, '') as codeInbounds"
            }, {
                "Item1": "Inbounds",
                "Item2": "codeDestination"
            }, {
                "Item1": "Inbounds",
                "Item2": "dateIn"
            }, {
                "Item1": "Inbounds",
                "Item2": "id as idInbound"
            }, {
                "Item1": "Inbounds",
                "Item2": "referenceInboundCode as referenceInboundCode"
            }, {
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "Id as IdInboundDeliveryNoteDetail"
            }, {
                "Item1": "Goods",
                "Item2": "id as idGood"
            }, {
                "Item1": "Goods",
                "Item2": "name as goodName"
            }, {
                "Item1": "Goods",
                "Item2": "code as goodCode"
            }, {
                "Item1": "Goods",
                "Item2": "sku as sku"
            }, {
                "Item1": "ListPalletTypes",
                "Item2": "id as idListPallet"
            }, {
                "Item1": "ListPalletTypes",
                "Item2": "name as listPalletName"
            }, {
                "Item1": "COUNT(DISTINCT(StockDetail",
                "Item2": "idPallet)) as palletsAmount"
            }, {
                "Item1": "SUM(StockDetail",
                "Item2": "totalCases) as totalCases"
            }, {
                "Item1": "StockDetail",
                "Item2": "goodsPerCase"
            }, {
                "Item1": "SUM(StockDetail",
                "Item2": "totalGoods) as totalGoods"
            }, {
                "Item1": "ISNULL((SELECT SUM(OutboundsDetail",
                "Item2": "TotalCases) FROM OutboundsDetail WHERE StockDetail.IdWarehouse = OutboundsDetail.IdWarehouse AND IdGood = StockDetail.IdGood AND Id NOT IN (SELECT IdOutboundDetail FROM OutboundsDeliveryNotesDetail WHERE Deleted = 0) AND IdInboundDeliveryNoteDetail = StockDetail.IdInboundDeliveryNoteDetail AND Deleted = 0), 0) as AllocatedCases"
            }, {
                "Item1": "SUM(StockDetail",
                "Item2": "totalCases) - ISNULL((SELECT SUM(TotalCases) FROM OutboundsDetail WHERE StockDetail.IdWarehouse = OutboundsDetail.IdWarehouse AND IdGood = StockDetail.IdGood AND Id NOT IN (SELECT IdOutboundDetail FROM OutboundsDeliveryNotesDetail WHERE Deleted = 0) AND IdInboundDeliveryNoteDetail = StockDetail.IdInboundDeliveryNoteDetail AND Deleted = 0), 0) as AvailableCases"
            }, {
                "Item1": "ISNULL((SELECT SUM(OutboundsDetail",
                "Item2": "TotalGoods) FROM OutboundsDetail WHERE StockDetail.IdWarehouse = OutboundsDetail.IdWarehouse AND IdGood = StockDetail.IdGood AND Id NOT IN (SELECT IdOutboundDetail FROM OutboundsDeliveryNotesDetail WHERE Deleted = 0) AND IdInboundDeliveryNoteDetail = StockDetail.IdInboundDeliveryNoteDetail AND Deleted = 0), 0) as AllocatedGoods"
            }, {
                "Item1": "SUM(StockDetail",
                "Item2": "totalGoods) - ISNULL((SELECT SUM(TotalGoods) FROM OutboundsDetail WHERE StockDetail.IdWarehouse = OutboundsDetail.IdWarehouse AND IdGood = StockDetail.IdGood AND Id NOT IN (SELECT IdOutboundDetail FROM OutboundsDeliveryNotesDetail WHERE Deleted = 0) AND IdInboundDeliveryNoteDetail = StockDetail.IdInboundDeliveryNoteDetail AND Deleted = 0), 0) as AvailableGoods"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "bestBeforeDate"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "language"
            }, {
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "weight"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "documentation"
            }, {
                "Item1": "StockDetail",
                "Item2": "idCompanySource"
            }, {
                "Item1": "StockDetail",
                "Item2": "idCompanyDestination"
            }, {
                "Item1": "StockDetail",
                "Item2": "idWarehouse"
            }, {
                "Item1": "SCAN_StockDetailScan",
                "Item2": "IdPalletCustomer"
            }],
            "tables": [
                { "Item1": "StockDetail" },
                { "Item1": "Warehouses" },
                { "Item1": "Customers" },
                { "Item1": "Goods" },
                { "Item1": "ListPalletTypes" },
                { "Item1": "InboundsDeliveryNotesDetail" },
                { "Item1": "InboundsDetail" },
                { "Item1": "Inbounds" },
                { "Item1": "SCAN_StockDetailScan" }
            ],
            "conditions": [
                { "Item1": "StockDetail", "Item2": "idCustomer", "Item3": "=", "Item4": idCustomer, "Item5": "AND" },
                { "Item1": "StockDetail", "Item2": "IdOutboundDeliveryNoteDetail", "Item3": "IS", "Item4": "null", "Item5": "AND" },
                { "Item1": "StockDetail", "Item2": "IdOutboundDetail", "Item3": "IS", "Item4": "null", "Item5": "AND" },
                { "Item1": "StockDetail", "Item2": "IdNoticeOfLossDetail", "Item3": "IS", "Item4": "null" }
            ],
            "joins": [
                { "Item1": "StockDetail", "Item2": "IdWarehouse", "Item3": "Warehouses", "Item4": "Id" },
                { "Item1": "StockDetail", "Item2": "IdCustomer", "Item3": "Customers", "Item4": "Id" },
                { "Item1": "StockDetail", "Item2": "IdGood", "Item3": "Goods", "Item4": "Id" },
                { "Item1": "StockDetail", "Item2": "IdListPallet", "Item3": "ListPalletTypes", "Item4": "Id" },
                { "Item1": "StockDetail", "Item2": "IdInboundDeliveryNoteDetail", "Item3": "InboundsDeliveryNotesDetail", "Item4": "Id" },
                { "Item1": "InboundsDeliveryNotesDetail", "Item2": "IdInboundDetail", "Item3": "InboundsDetail", "Item4": "Id" },
                { "Item1": "InboundsDetail", "Item2": "IdInbound", "Item3": "Inbounds", "Item4": "Id" },
                { "Item1": "StockDetail", "Item2": "IdPallet", "Item3": "SCAN_StockDetailScan", "Item4": "IdPallet" }
            ],
            "groupBy": [
                { "Item1": "StockDetail.idWarehouse" },
                { "Item1": "Warehouses.name" },
                { "Item1": "StockDetail.IdWarehouse" },
                { "Item1": "Customers.name" },
                { "Item1": "Goods.id" },
                { "Item1": "Goods.name" },
                { "Item1": "Goods.code" },
                { "Item1": "Goods.sku" },
                { "Item1": "Inbounds.code" },
                { "Item1": "Inbounds.dateIn" },
                { "Item1": "Inbounds.codeDestination" },
                { "Item1": "Inbounds.Id" },
                { "Item1": "Inbounds.referenceInboundCode" },
                { "Item1": "ListPalletTypes.id" },
                { "Item1": "ListPalletTypes.name" },
                { "Item1": "StockDetail.idCustomer" },
                { "Item1": "StockDetail.totalCases" },
                { "Item1": "StockDetail.goodsPerCase" },
                { "Item1": "StockDetail.totalGoods" },
                { "Item1": "InboundsDetail.bestBeforeDate" },
                { "Item1": "InboundsDeliveryNotesDetail.id" },
                { "Item1": "InboundsDeliveryNotesDetail.weight" },
                { "Item1": "InboundsDetail.language" },
                { "Item1": "InboundsDetail.documentation" },
                { "Item1": "StockDetail.IdCompanySource" },
                { "Item1": "StockDetail.IdInboundDeliveryNoteDetail" },
                { "Item1": "StockDetail.IdCompanyDestination" },
                { "Item1": "SCAN_StockDetailScan.IdPalletCustomer" },
                { "Item1": "StockDetail.IdWarehouse" }, // ✅ Incluido correctamente en el groupBy
                { "Item1": "StockDetail.IdGood) A GROUP BY " +
                    "A.warehouseName, A.customerName, A.codeInbounds, A.codeDestination, A.dateIn, A.idInbound, A.IdInboundDeliveryNoteDetail, A.IdCompanyDestination, " +
                    "A.referenceInboundCode, A.idGood, A.idListPallet, A.goodName, A.goodCode, A.sku,A.listPalletName, A.goodsPerCase, " +
                    "A.bestBeforeDate, A.weight, A.language, A.documentation, A.TotalCases, A.PalletsAmount, A.IdPalletCustomer, A.IdWarehouse, A.IdCustomer) B" }
            ],
            "orderBy": [
                { "Item1": "B.goodName" },
                { "Item1": "B.codeInbounds" }
            ]
        };
        return json;
    }

    private getJsonReadGroupByPalletsAndCustomerAndInboundCode(idCustomer: string, inboundCode: string): any {
        const json = {
            "fields": [{
                "Item1": "*, (B.PalletsAmount - B.PalletsAmountSell) AS AvailablePalletsAmountFinal, (B.AvailableCasesFinal - B.sellCases) AS AvailableCasesFinal, (B.AvailableGoodsFinal - B.sellGoods) AS AvailableGoodsFinal FROM (SELECT A.warehouseName, A.customerName, A.codeInbounds, A.codeDestination, A.idInbound, A.IdInboundDeliveryNoteDetail, A.referenceInboundCode, A.idGood, A.idListPallet, A.goodName, A.listPalletName, SUM(A.palletsAmount) AS palletsAmount, SUM(A.totalCases) AS totalCases, SUM(A.AllocatedCases) AS AllocatedCases, SUM(A.AvailableCasesFinal) AS AvailableCasesFinal, A.goodsPerCase, SUM(A.totalGoods) AS totalGoods, SUM(A.AllocatedGoods) AS AllocatedGoods, SUM(A.AvailableGoodsFinal) AS AvailableGoodsFinal, A.bestBeforeDate, A.language, A.documentation, A.weight, A.IdWarehouse, A.IdCustomer, " +
                "STUFF((SELECT DISTINCT ' | ' + SD2.Location FROM StockDetail SD2 WHERE SD2.IdInboundDeliveryNoteDetail = A.IdInboundDeliveryNoteDetail AND SD2.IdWarehouse = A.IdWarehouse AND SD2.IdGood = A.IdGood AND SD2.IdListPallet = A.IdListPallet AND SD2.IdCustomer = A.IdCustomer AND SD2.IdOutboundDeliveryNoteDetail IS NULL AND SD2.IdOutboundDetail IS NULL AND SD2.IdNoticeOfLossDetail IS NULL FOR XML PATH(''), TYPE).value('.', 'NVARCHAR(MAX)'), 1, 3, '') AS location, " +
                "ISNULL((SELECT SUM(SellsDetail.PalletsAmount) FROM SellsDetail LEFT OUTER JOIN Sells ON (SellsDetail.IdSell = Sells.Id) WHERE IdGood = A.IdGood AND IdInbound = A.IdInbound AND IdListPallet = A.IdListPallet AND IdinboundDeliveryNoteDetail = A.IdinboundDeliveryNoteDetail AND SellsDetail.Deleted = 0 " + SELL_STATUS_EXCLUDED_SQL_FILTER + "), 0) AS palletsAmountSell, " +
                "ISNULL((SELECT SUM(SellsDetail.CasesAmountPallet) FROM SellsDetail LEFT OUTER JOIN Sells ON (SellsDetail.IdSell = Sells.Id) WHERE IdGood = A.IdGood AND IdInbound = A.IdInbound AND IdListPallet = A.IdListPallet AND IdinboundDeliveryNoteDetail = A.IdinboundDeliveryNoteDetail AND SellsDetail.Deleted = 0 " + SELL_STATUS_EXCLUDED_SQL_FILTER + "), 0) AS sellCases, " +
                "ISNULL((SELECT SellsDetail.GoodsPerCase * SUM(SellsDetail.CasesAmountPallet) FROM SellsDetail LEFT OUTER JOIN Sells ON (SellsDetail.IdSell = Sells.Id) WHERE IdGood = A.IdGood AND IdInbound = A.IdInbound AND IdListPallet = A.IdListPallet AND IdinboundDeliveryNoteDetail = A.IdinboundDeliveryNoteDetail AND SellsDetail.Deleted = 0 " + SELL_STATUS_EXCLUDED_SQL_FILTER + " GROUP BY SellsDetail.GoodsPerCase), 0) AS sellGoods " +
                "FROM (SELECT Warehouses",
                "Item2": "name as warehouseName"
            }, {
                "Item1": "StockDetail",
                "Item2": "idCustomer"
            }, {
                "Item1": "Customers",
                "Item2": "name as customerName"
            }, {
                "Item1": "ISNULL(Inbounds",
                "Item2": "code, '') as codeInbounds"
            }, {
                "Item1": "Inbounds",
                "Item2": "codeDestination"
            }, {
                "Item1": "Inbounds",
                "Item2": "id as idInbound"
            }, {
                "Item1": "Inbounds",
                "Item2": "referenceInboundCode as referenceInboundCode"
            }, {
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "Id as IdInboundDeliveryNoteDetail"
            }, {
                "Item1": "Goods",
                "Item2": "id as idGood"
            }, {
                "Item1": "Goods",
                "Item2": "name as goodName"
            }, {
                "Item1": "ListPalletTypes",
                "Item2": "id as idListPallet"
            }, {
                "Item1": "ListPalletTypes",
                "Item2": "name as listPalletName"
            }, {
                "Item1": "COUNT(DISTINCT(StockDetail",
                "Item2": "idPallet)) as palletsAmount"
            }, {
                "Item1": "SUM(StockDetail",
                "Item2": "totalCases) as totalCases"
            }, {
                "Item1": "StockDetail",
                "Item2": "goodsPerCase"
            }, {
                "Item1": "SUM(StockDetail",
                "Item2": "totalGoods) as totalGoods"
            }, {
                "Item1": "ISNULL((SELECT SUM(OutboundsDetail",
                "Item2": "TotalCases) FROM OutboundsDetail WHERE StockDetail.IdWarehouse = OutboundsDetail.IdWarehouse AND IdGood = StockDetail.IdGood AND Id NOT IN (SELECT IdOutboundDetail FROM OutboundsDeliveryNotesDetail WHERE Deleted = 0) AND IdInboundDeliveryNoteDetail = StockDetail.IdInboundDeliveryNoteDetail AND Deleted = 0), 0) as AllocatedCases"
            }, {
                "Item1": "SUM(StockDetail",
                "Item2": "totalCases) - ISNULL((SELECT SUM(TotalCases) FROM OutboundsDetail WHERE StockDetail.IdWarehouse = OutboundsDetail.IdWarehouse AND IdGood = StockDetail.IdGood AND Id NOT IN (SELECT IdOutboundDetail FROM OutboundsDeliveryNotesDetail WHERE Deleted = 0) AND IdInboundDeliveryNoteDetail = StockDetail.IdInboundDeliveryNoteDetail AND Deleted = 0), 0) as AvailableCasesFinal"
            }, {
                "Item1": "ISNULL((SELECT SUM(OutboundsDetail",
                "Item2": "TotalGoods) FROM OutboundsDetail WHERE StockDetail.IdWarehouse = OutboundsDetail.IdWarehouse AND IdGood = StockDetail.IdGood AND Id NOT IN (SELECT IdOutboundDetail FROM OutboundsDeliveryNotesDetail WHERE Deleted = 0) AND IdInboundDeliveryNoteDetail = StockDetail.IdInboundDeliveryNoteDetail AND Deleted = 0), 0) as AllocatedGoods"
            }, {
                "Item1": "SUM(StockDetail",
                "Item2": "totalGoods) - ISNULL((SELECT SUM(TotalGoods) FROM OutboundsDetail WHERE StockDetail.IdWarehouse = OutboundsDetail.IdWarehouse AND IdGood = StockDetail.IdGood AND Id NOT IN (SELECT IdOutboundDetail FROM OutboundsDeliveryNotesDetail WHERE Deleted = 0) AND IdInboundDeliveryNoteDetail = StockDetail.IdInboundDeliveryNoteDetail AND Deleted = 0), 0) as AvailableGoodsFinal"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "bestBeforeDate"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "language"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "documentation"
            }, {
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "weight"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdWarehouse"
            }],
            "tables": [
                { "Item1": "StockDetail" },
                { "Item1": "Warehouses" },
                { "Item1": "Customers" },
                { "Item1": "Goods" },
                { "Item1": "ListPalletTypes" },
                { "Item1": "InboundsDeliveryNotesDetail" },
                { "Item1": "InboundsDetail" },
                { "Item1": "Inbounds" }
            ],
            "conditions": [
                { "Item1": "StockDetail", "Item2": "idCustomer", "Item3": "=", "Item4": idCustomer, "Item5": "AND" },
                { "Item1": "StockDetail", "Item2": "IdOutboundDeliveryNoteDetail", "Item3": "IS", "Item4": "null", "Item5": "AND" },
                { "Item1": "Inbounds", "Item2": "Code", "Item3": "=", "Item4": inboundCode, "Item5": "AND" },
                { "Item1": "StockDetail", "Item2": "IdOutboundDetail", "Item3": "IS", "Item4": "null", "Item5": "AND" },
                { "Item1": "StockDetail", "Item2": "IdNoticeOfLossDetail", "Item3": "IS", "Item4": "null" }
            ],
            "joins": [
                { "Item1": "StockDetail", "Item2": "IdWarehouse", "Item3": "Warehouses", "Item4": "Id" },
                { "Item1": "StockDetail", "Item2": "IdCustomer", "Item3": "Customers", "Item4": "Id" },
                { "Item1": "StockDetail", "Item2": "IdGood", "Item3": "Goods", "Item4": "Id" },
                { "Item1": "StockDetail", "Item2": "IdListPallet", "Item3": "ListPalletTypes", "Item4": "Id" },
                { "Item1": "StockDetail", "Item2": "IdInboundDeliveryNoteDetail", "Item3": "InboundsDeliveryNotesDetail", "Item4": "Id" },
                { "Item1": "InboundsDeliveryNotesDetail", "Item2": "IdInboundDetail", "Item3": "InboundsDetail", "Item4": "Id" },
                { "Item1": "InboundsDetail", "Item2": "IdInbound", "Item3": "Inbounds", "Item4": "Id" }
            ],
            "groupBy": [
                { "Item1": "Warehouses.name" },
                { "Item1": "StockDetail.IdWarehouse" },
                { "Item1": "Customers.name" },
                { "Item1": "Goods.id" },
                { "Item1": "Goods.name" },
                { "Item1": "Inbounds.code" },
                { "Item1": "Inbounds.codeDestination" },
                { "Item1": "Inbounds.Id" },
                { "Item1": "Inbounds.referenceInboundCode" },
                { "Item1": "ListPalletTypes.id" },
                { "Item1": "ListPalletTypes.name" },
                { "Item1": "StockDetail.idCustomer" },
                { "Item1": "StockDetail.totalCases" },
                { "Item1": "StockDetail.goodsPerCase" },
                { "Item1": "StockDetail.totalGoods" },
                { "Item1": "InboundsDetail.bestBeforeDate" },
                { "Item1": "InboundsDeliveryNotesDetail.id" },
                { "Item1": "InboundsDetail.language" },
                { "Item1": "InboundsDetail.documentation" },
                { "Item1": "InboundsDeliveryNotesDetail.weight" },
                { "Item1": "StockDetail.IdCompanySource" },
                { "Item1": "StockDetail.IdInboundDeliveryNoteDetail" },
                { "Item1": "StockDetail.IdGood) A GROUP BY A.warehouseName, A.customerName, A.codeInbounds, A.codeDestination, A.idInbound, A.IdInboundDeliveryNoteDetail, A.referenceInboundCode, A.idGood, A.idListPallet, A.goodName, A.listPalletName, A.goodsPerCase, A.bestBeforeDate, A.language, A.documentation, A.weight, A.Totalcases, A.PalletsAmount, A.IdCustomer, A.IdWarehouse) B" }
            ],
            "orderBy": [
                { "Item1": "B.goodName" },
                { "Item1": "B.codeInbounds" }
            ]
        };
        return json;
    }

    private getJsonReadGroupByCustomer(idCustomer: string) : any {
        const json = {
            "fields": [{
                "Item1": "Warehouses",
                "Item2": "name as warehouseName"
            }, {
                "Item1": "StockDetail",
                "Item2": "idCustomer"
            }, {
                "Item1": "Customers",
                "Item2": "name as customerName"
            }, {
                "Item1": "ISNULL(Inbounds",
                "Item2": "code, (SELECT Code FROM Inbounds WHERE Id IN (SELECT IdInbound FROM Transformations WHERE Id IN (SELECT IdTransformation FROM TransformationsPalletsDestination WHERE Id = StockDetail.IdTransformationPalletDestination)))) as codeInbounds"
            }, {
                "Item1": "Inbounds",
                "Item2": "codeDestination"
            }, {
                "Item1": "Inbounds",
                "Item2": "referenceInboundCode as referenceInboundCode"
            }, {
                "Item1": "Inbounds",
                "Item2": "dateIn"
            }, {
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "weight"
            }, {
                "Item1": "ListPalletTypes",
                "Item2": "name as listPalletName"
            }, {
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "Id as IdInboundDeliveryNoteDetail"
            }, {
                "Item1": "Goods",
                "Item2": "name as goodName"
            }, {
                "Item1": "Goods",
                "Item2": "code as goodCode"
            }, {
                "Item1": "Goods",
                "Item2": "sku"
            }, {
                "Item1": "COUNT(DISTINCT(StockDetail",
                "Item2": "IdPallet)) as palletsAmount"
            }, {
                "Item1": "SUM(StockDetail",
                "Item2": "totalCases) as totalCases"
            }, {
                "Item1": "StockDetail",
                "Item2": "goodsPerCase"
            }, {
                "Item1": "SUM(StockDetail",
                "Item2": "totalGoods) as totalGoods"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "bestBeforeDate"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "language"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "documentation"
            }, {
                "Item1": "StockDetail",
                "Item2": "idPallet"
            }, {
                "Item1": "StockDetail",
                "Item2": "location"
            }, {
                "Item1": "IIF(StockDetail",
                "Item2": "IdTransformationPalletDestination IS NULL, 'No', 'Yes') AS isTransformed"
            }, {
                "Item1": "Companies",
                "Item2": "Name as companyDestination"
            }, {
                "Item1": "StockDetail",
                "Item2": "idListPallet"
            }, {
                "Item1": "SCAN_StockDetailScan",
                "Item2": "IdPalletCustomer"
            }],
            "tables": [{
                "Item1": "StockDetail"
            }, {
                "Item1": "Warehouses"
            }, {
                "Item1": "Customers"
            }, {
                "Item1": "Goods"
            }, {
                "Item1": "ListPalletTypes"
            }, {
                "Item1": "InboundsDeliveryNotesDetail"
            }, {
                "Item1": "InboundsDetail"
            }, {
                "Item1": "Inbounds"
            }, {
                "Item1": "Companies"
            }, {
                "Item1": "SCAN_StockDetailScan"
            }],
            "conditions": [{
                "Item1": "StockDetail",
                "Item2": "idCustomer",
                "Item3": "=",
                "Item4": idCustomer,
                "Item5": "AND"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdOutboundDeliveryNoteDetail",
                "Item3": "IS",
                "Item4": "null",
                "Item5": "AND"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdOutboundDetail",
                "Item3": "IS",
                "Item4": "null",
                "Item5": "AND"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdNoticeOfLossDetail",
                "Item3": "IS",
                "Item4": "null"
            }],
            "joins": [{
                "Item1": "StockDetail",
                "Item2": "IdWarehouse",
                "Item3": "Warehouses",
                "Item4": "Id"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdCustomer",
                "Item3": "Customers",
                "Item4": "Id"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdGood",
                "Item3": "Goods",
                "Item4": "Id"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdListPallet",
                "Item3": "ListPalletTypes",
                "Item4": "Id"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdInboundDeliveryNoteDetail",
                "Item3": "InboundsDeliveryNotesDetail",
                "Item4": "Id"
            }, {
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "IdInboundDetail",
                "Item3": "InboundsDetail",
                "Item4": "Id"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "IdInbound",
                "Item3": "Inbounds",
                "Item4": "Id"
            }, {
                "Item1": "Inbounds",
                "Item2": "IdCompanyDestination",
                "Item3": "Companies",
                "Item4": "Id"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdPallet",
                "Item3": "SCAN_StockDetailScan",
                "Item4": "IdPallet"
            }],
            "groupBy": [{
                "Item1": "Warehouses.name"
            }, {
                "Item1": "Customers.name"
            }, {
                "Item1": "Goods.name"
            }, {
                "Item1": "Goods.code"
            }, {
                "Item1": "Goods.sku"
            }, {
                "Item1": "Inbounds.code"
            }, {
                "Item1": "InboundsDeliveryNotesDetail.weight"
            }, {
                "Item1": "Inbounds.dateIn"
            }, {
                "Item1": "Inbounds.codeDestination"
            }, {
                "Item1": "Inbounds.referenceInboundCode"
            }, {
                "Item1": "ListPalletTypes.name"
            }, {
                "Item1": "StockDetail.idCustomer"
            }, {
                "Item1": "StockDetail.idGood"
            }, {
                "Item1": "StockDetail.idPallet"
            }, {
                "Item1": "StockDetail.location"
            }, {
                "Item1": "StockDetail.totalCases"
            }, {
                "Item1": "StockDetail.goodsPerCase"
            }, {
                "Item1": "StockDetail.totalGoods"
            }, {
                "Item1": "InboundsDetail.bestBeforeDate"
            }, {
                "Item1": "InboundsDeliveryNotesDetail.Id"
            }, {
                "Item1": "StockDetail.IdWarehouse"
            }, {
                "Item1": "InboundsDetail.language"
            }, {
                "Item1": "InboundsDetail.documentation"
            }, {
                "Item1": "StockDetail.IdTransformationPalletDestination"
            }, {
                "Item1": "Companies.Name"
            }, {
                "Item1": "StockDetail.idListPallet"
            }, {
                "Item1": "SCAN_StockDetailScan.IdPalletCustomer"
            }]
        };
        return json;
    }

    private getJsonReadGroupByCustomerOutbound(idCustomer: string) : any {
        const json = {
            "fields": [{
                "Item1": "Warehouses",
                "Item2": "name as warehouseName"
            }, {
                "Item1": "StockDetail",
                "Item2": "idCustomer"
            }, {
                "Item1": "Customers",
                "Item2": "name as customerName"
            }, {
                "Item1": "ISNULL(Inbounds",
                "Item2": "code, (SELECT Code FROM Inbounds WHERE Id IN (SELECT IdInbound FROM Transformations WHERE Id IN (SELECT IdTransformation FROM TransformationsPalletsDestination WHERE Id = StockDetail.IdTransformationPalletDestination)))) as codeInbounds"
            }, {
                "Item1": "Inbounds",
                "Item2": "codeDestination"
            }, {
                "Item1": "Inbounds",
                "Item2": "referenceInboundCode as referenceInboundCode"
            }, {
                "Item1": "ListPalletTypes",
                "Item2": "name as listPalletName"
            }, {
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "Id as IdInboundDeliveryNoteDetail"
            }, {
                "Item1": "Goods",
                "Item2": "id as idGood"
            }, {
                "Item1": "Goods",
                "Item2": "name as goodName"
            }, {
                "Item1": "SUM(StockDetail",
                "Item2": "totalCases) - ISNULL((SELECT SUM(TotalCases) FROM OutboundsDetail WHERE IdGood = StockDetail.IdGood AND Id NOT IN (SELECT IdOutboundDetail FROM OutboundsDeliveryNotesDetail WHERE Deleted = 0) AND IdInboundDeliveryNoteDetail = StockDetail.IdInboundDeliveryNoteDetail AND Deleted = 0), 0) as totalCases"
            }, {
                "Item1": "StockDetail",
                "Item2": "goodsPerCase"
            }, {
                "Item1": "SUM(StockDetail",
                "Item2": "totalGoods) - ISNULL((SELECT SUM(TotalGoods) FROM OutboundsDetail WHERE IdGood = StockDetail.IdGood AND Id NOT IN (SELECT IdOutboundDetail FROM OutboundsDeliveryNotesDetail WHERE Deleted = 0) AND IdInboundDeliveryNoteDetail = StockDetail.IdInboundDeliveryNoteDetail AND Deleted = 0), 0) as totalGoods"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "bestBeforeDate"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "language"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "documentation"
            }, {
                "Item1": "IIF(StockDetail",
                "Item2": "IdTransformationPalletDestination IS NULL, 'No', 'Yes') AS isTransformed"
            }],
            "tables": [{
                "Item1": "StockDetail"
            }, {
                "Item1": "Warehouses"
            }, {
                "Item1": "Customers"
            }, {
                "Item1": "Goods"
            }, {
                "Item1": "ListPalletTypes"
            }, {
                "Item1": "InboundsDeliveryNotesDetail"
            }, {
                "Item1": "InboundsDetail"
            }, {
                "Item1": "Inbounds"
            }],
            "conditions": [{
                "Item1": "StockDetail",
                "Item2": "idCustomer",
                "Item3": "=",
                "Item4": idCustomer,
                "Item5": "AND"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdOutboundDeliveryNoteDetail",
                "Item3": "IS",
                "Item4": "null",
                "Item5": "AND"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdOutboundDetail",
                "Item3": "IS",
                "Item4": "null",
                "Item5": "AND"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdNoticeOfLossDetail",
                "Item3": "IS",
                "Item4": "null"
            }],
            "joins": [{
                "Item1": "StockDetail",
                "Item2": "IdWarehouse",
                "Item3": "Warehouses",
                "Item4": "Id"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdCustomer",
                "Item3": "Customers",
                "Item4": "Id"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdGood",
                "Item3": "Goods",
                "Item4": "Id"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdListPallet",
                "Item3": "ListPalletTypes",
                "Item4": "Id"
            }, {
                "Item1": "StockDetail",
                "Item2": "IdInboundDeliveryNoteDetail",
                "Item3": "InboundsDeliveryNotesDetail",
                "Item4": "Id"
            }, {
                "Item1": "InboundsDeliveryNotesDetail",
                "Item2": "IdInboundDetail",
                "Item3": "InboundsDetail",
                "Item4": "Id"
            }, {
                "Item1": "InboundsDetail",
                "Item2": "IdInbound",
                "Item3": "Inbounds",
                "Item4": "Id"
            }],
            "groupBy": [{
                "Item1": "Warehouses.name"
            }, {
                "Item1": "Customers.name"
            }, {
                "Item1": "Goods.id"
            }, {
                "Item1": "Goods.name"
            }, {
                "Item1": "Inbounds.codeDestination"
            }, {
                "Item1": "Inbounds.code"
            }, {
                "Item1": "Inbounds.referenceInboundCode"
            }, {
                "Item1": "ListPalletTypes.name"
            }, {
                "Item1": "StockDetail.idCustomer"
            }, {
                "Item1": "StockDetail.idGood"
            }, {
                "Item1": "StockDetail.totalCases"
            }, {
                "Item1": "StockDetail.goodsPerCase"
            }, {
                "Item1": "StockDetail.totalGoods"
            }, {
                "Item1": "InboundsDetail.bestBeforeDate"
            }, {
                "Item1": "InboundsDeliveryNotesDetail.Id"
            }, {
                "Item1": "StockDetail.IdWarehouse"
            }, {
                "Item1": "InboundsDetail.language"
            }, {
                "Item1": "InboundsDetail.documentation"
            }, {
                "Item1": "StockDetail.IdInboundDeliveryNoteDetail"
            }, {
                "Item1": "StockDetail.IdTransformationPalletDestination"
            }]
        };
        return json;
    }

    private getJsonReadStockPalletsAmount(item: any): any {
        const json = {
            "fields": [
                {
                    "Item1": "StockDetail",
                    "Item2": "IdPallet as idPallet"
                },
                {
                    "Item1": "COUNT(StockDetail",
                    "Item2": "IdPallet) as totalCases"
                },
                {
                    "Item1": "MAX(StockDetail",
                    "Item2": "location) as location"
                }
            ],
            "tables": [
                {
                    "Item1": "StockDetail"
                }
            ],
            "conditions": [
                {
                    "Item1": "StockDetail",
                    "Item2": "IdInboundDeliveryNoteDetail",
                    "Item3": "=",
                    "Item4": item.idInboundDeliveryNoteDetail,
                    "Item5": "AND"
                },
                {
                    "Item1": "StockDetail",
                    "Item2": "DateOut",
                    "Item3": "IS",
                    "Item4": "null",
                    "Item5": "AND"
                },
                {
                    "Item1": "StockDetail",
                    "Item2": "IdWarehouse",
                    "Item3": "=",
                    "Item4": item.idWarehouse
                }
            ],
            "groupBy": [
                {
                    "Item1": "StockDetail.IdPallet"
                }
            ]
        };
        return json;
    }

    private getConcatIds(idWarehouses: string[]) : string {
        let concatString: string = "(";
        for (let id of idWarehouses) {
            concatString = concatString.concat("'" + id + "',");
        }
        
        concatString = concatString.slice(0, concatString.length - 1);
        concatString = concatString.concat(")");
        return concatString;
    }
}
